module.exports = {
  "NlFLFu": "Vui lòng điền đầy đủ thông tin để tạo/ cập nhật điểm dừng",
  "app.common.cancel": "Hủy",
  "app.common.confirm": "Đồng ý",
  "app.common.delete_success": "Xóa thành công",
  "app.common.deleting": "Đang xóa...",
  "app.copyright.produced": "Bản quyền thuộc về AnVui",
  "common.actions.active": "Mở khóa",
  "common.actions.config_app": "Cấu hình App",
  "common.actions.config_fee": "Chỉnh sửa giá dịch vụ",
  "common.actions.create_web": "Tạo web nhà xe",
  "common.actions.delete": "Xóa",
  "common.actions.delete_completely": "Xóa hoàn toàn",
  "common.actions.inactive": "Khóa",
  "common.actions.reset": "Reset thiết bị",
  "common.actions.update": "Cập nhật",
  "common.actions.update_menu": "Gán chức năng",
  "common.actions.view": "Xem chi tiết",
  "common.button.activate": "Kích hoạt",
  "common.button.addStaff": "Thêm nhân viên",
  "common.button.batchActive": "Mở khóa hàng loạt",
  "common.button.batchInactive": "Khóa hàng loạt",
  "common.button.cancel": "Hủy bỏ",
  "common.button.check": "Kiểm tra",
  "common.button.deactivate": "Vô hiệu hóa",
  "common.button.delete": "Xóa",
  "common.button.deposit": "Nạp tiền",
  "common.button.edit": "Sửa",
  "common.button.excel_exporter": "Xuất Excel",
  "common.button.filter": "Lấy dữ liệu",
  "common.button.new": "Tạo mới",
  "common.button.register": "Đăng ký",
  "common.button.save": "Lưu",
  "common.button.update": "Cập nhật",
  "common.button.view": "Xem",
  "common.enums.active.13": "Phí Zalo OA",
  "common.enums.active.2": "Phí SMS",
  "common.enums.active.24": "Phí VietQR",
  "common.enums.active.25": "Phí trung chuyển An Vui",
  "common.enums.active.3": "Phí HĐĐT theo lần xuất",
  "common.enums.active.4": "Phí HĐĐT theo số chuyến",
  "common.enums.active.5": "Phí tổng đài",
  "common.enums.active.false": "Khóa",
  "common.enums.active.true": "Hoạt động",
  "common.enums.balance_type.14": "Phí xuất bến",
  "common.enums.company_status.1": "Tạm khóa",
  "common.enums.company_status.2": "Hoạt động",
  "common.enums.company_status.4": "Ngưng hoạt động",
  "common.enums.company_status.5": "Đã xóa",
  "common.enums.customer__status.1": "Mới nhập liệu",
  "common.enums.customer__status.2": "Đã gọi",
  "common.enums.customer_type.0": "Đã ký hợp đồng",
  "common.enums.customer_type.1": "Tiềm năng",
  "common.enums.customer_type.2": "Chuẩn bị ký hợp đồng",
  "common.enums.data_sync_state.false": "Thiếu",
  "common.enums.data_sync_state.true": "Đầy đủ",
  "common.enums.depositType.others": "Qua nhân viên",
  "common.enums.depositType.vietqr": "Qua VietQR",
  "common.enums.language.en": "English",
  "common.enums.language.vi": "Tiếng Việt",
  "common.enums.mb_payment_status.new": "Mới tạo",
  "common.enums.mb_payment_status.success": "Thanh toán",
  "common.enums.mb_terminal_status.delete": "Đã xóa",
  "common.enums.mb_terminal_status.deny": "Bị từ chối",
  "common.enums.mb_terminal_status.new": "Chờ phê duyệt",
  "common.enums.mb_terminal_status.success": "Đã phê duyệt",
  "common.enums.mb_terminal_status.verified": "Đã xác thực OTP",
  "common.enums.payment_gateway.bidv": "BIDV",
  "common.enums.payment_gateway.mb": "MB",
  "common.fields.status": "Trạng thái",
  "common.fields.updatedAt": "Cập nhật lần cuối",
  "common.message.addError": "Thêm dữ liệu thất bại. Mã lỗi: {error}",
  "common.message.addSuccess": "Thêm dữ liệu thành công",
  "common.message.adding": "Đang thêm dữ liệu...",
  "common.message.deleteError": "Xóa dữ liệu thất bại. Mã lỗi: {error}",
  "common.message.deleteSuccess": "Xóa dữ liệu thành công",
  "common.message.deleting": "Đang xóa dữ liệu...",
  "common.message.updateError": "Cập nhật dữ liệu thất bại. Mã lỗi: {error}",
  "common.message.updateSuccess": "Cập nhật dữ liệu thành công",
  "common.message.updating": "Đang cập nhật dữ liệu...",
  "common.message.uploadError": "Tải tập tin lên thất bại. Mã lỗi: {error}",
  "common.message.uploadSuccess": "Tải tập tin lên thành công",
  "common.message.uploading": "Đang tải tập tin lên...",
  "common.modal.changeStatus.active": "Bạn có chắc chắn muốn mở khóa?",
  "common.modal.changeStatus.inactive": "Bạn có chắc chắn muốn khóa?",
  "common.no": "Không",
  "common.search.date": "Thời gian",
  "common.status.active": "Hoạt động",
  "common.status.inactive": "Bị khóa",
  "common.table.footer.status": "| Hoạt động: {active} | Bị khóa: {inactive}",
  "common.table.footerText": "| Hoạt động: {active} | Bị khóa: {inactive}",
  "common.text.all": "Tất cả",
  "common.text.amount": "Số tiền",
  "common.text.chosen": "Đã chọn",
  "common.text.index": "STT",
  "common.text.item": "mục",
  "common.text.operating": "Hành động",
  "common.text.quantity": "Số lượng",
  "common.text.search": "Tìm kiếm",
  "common.text.total": "Tổng cộng",
  "common.tips.search_like": "Tìm gần đúng",
  "common.yes": "Có",
  "components.introduction.button.back": "Quay lại",
  "components.introduction.button.close": "Đóng",
  "components.introduction.button.next": "Tiếp theo {progress}",
  "components.introduction.button.skip": "Bỏ qua",
  "components.rightContent.userMenu.changePassword": "Đổi mật khẩu",
  "components.rightContent.userMenu.logout": "Đăng xuất",
  "components.rightContent.userMenu.profile": "Hồ sơ cá nhân",
  "errors.already_register": "Số điện thoại đã đăng ký",
  "errors.is_duplicate": "{field} đã tồn tại",
  "errors.mongo_error_duplicate": "Có lỗi xảy ra, hãy kiểm tra dữ liệu nhập!",
  "errors.password_not_correct": "Mật khẩu cũ không đúng!",
  "errors.unprocessable_entity": "Dữ liệu chưa đúng!",
  "errors.user_already_exists": "Tài khoản đã tồn tại, hãy nhập tên tài khoản khác!",
  "errors.user_exists_with_same_username": "Tên đăng nhập đã tồn tại!",
  "menu.company.company-partner": "Đối tác bán vé",
  "modal.button.back": "Quay lại",
  "modal.button.cancel": "Hủy bỏ",
  "modal.button.ok": "Đồng ý",
  "modal.confirmLeaving.content": "Bạn có muốn bỏ qua các thay đổi không?",
  "modal.confirmLeaving.title": "Xác nhận hủy thay đổi",
  "modal.delete.title": "Bạn có chắc chắn muốn xoá?",
  "modal.deny.title": "Bạn có chắc chắn muốn từ chối các cổng thanh toán đã chọn?",
  "pages.account.button.changePassword": "Đổi mật khẩu",
  "pages.account.error.password_not_match": "Mật khẩu mới không khớp nhau",
  "pages.account.fields.newPassword": "Mật khẩu mới",
  "pages.account.fields.newPassword.required": "Hãy nhập mật khẩu mới!",
  "pages.account.fields.newPasswordAgain": "Nhập lại mật khẩu mới",
  "pages.account.fields.newPasswordAgain.required": "Hãy nhập lại mật khẩu mới!",
  "pages.account.fields.oldPassword": "Mật khẩu cũ",
  "pages.account.fields.oldPassword.required": "Hãy nhập mật khẩu!",
  "pages.account.tab.password": "Đổi mật khẩu",
  "pages.account.tab.profile": "Hồ sơ",
  "pages.account.userprofile.avatar.remove": "Xóa ảnh",
  "pages.account.userprofile.avatar.upload": "Tải ảnh lên",
  "pages.admin.subPage.title": "This page can only be viewed by admin",
  "pages.balance-fluctuation-missing.check.title": "Kiểm tra trừ phí",
  "pages.balance-fluctuation-missing.fields.balanceType": "Loại chi phí",
  "pages.balance-fluctuation-missing.fields.payDateInt": "Ngày kiểm tra",
  "pages.balance-fluctuation-missing.table.title": "Danh sách nhà xe trừ thiếu chi phí",
  "pages.balance-fluctuation.actions.refund": "Hoàn tiền",
  "pages.balance-fluctuation.button.run": "Chạy lại trừ phí",
  "pages.balance-fluctuation.detailForm.title": "Thông tin chi tiết giao dịch",
  "pages.balance-fluctuation.fields.amount": "Số tiền",
  "pages.balance-fluctuation.fields.balanceType": "Loại chi phí",
  "pages.balance-fluctuation.fields.dateMsAction": "Ngày tính phí",
  "pages.balance-fluctuation.fields.description": "Diễn giải",
  "pages.balance-fluctuation.fields.detailsType": "Chi tiết chi phí",
  "pages.balance-fluctuation.fields.id": "Mã giao dịch",
  "pages.balance-fluctuation.fields.note": "Ghi chú",
  "pages.balance-fluctuation.fields.payDateInt": "Ngày giao dịch",
  "pages.balance-fluctuation.modal.refund.title": "Bạn có chắc chắn muốn hoàn tiền?",
  "pages.balance-fluctuation.run-pay-fee.title": "Chạy trừ phí hệ thống thủ công",
  "pages.balance-fluctuation.table.title": "Danh sách giao dịch ví hệ thống",
  "pages.bidv.terminals.detailForm.title": "Thông tin chi tiết cổng thanh toán BIDV QR",
  "pages.bidv.terminals.modals.approve": "Bạn có chắc chắn muốn phê duyệt?",
  "pages.bidv.terminals.modals.deny": "Bạn có chắc chắn muốn từ chối?",
  "pages.bidvqr.payments.detailForm.title": "Thông tin chi tiết giao dịch",
  "pages.bidvqr.payments.fields.billNumber": "Mã giao dịch",
  "pages.bidvqr.payments.fields.billNumber.tips": "Mã giao dịch của AV",
  "pages.bidvqr.payments.fields.callbackRespCode": "Kết quả callback",
  "pages.bidvqr.payments.fields.callbackRespDesc": "Nội dung callback",
  "pages.bidvqr.payments.fields.content": "Ghi chú",
  "pages.bidvqr.payments.fields.createdAt": "Ngày tạo",
  "pages.bidvqr.payments.fields.description": "Mô tả chi tiết",
  "pages.bidvqr.payments.fields.feeAmount": "Tiền phí QR",
  "pages.bidvqr.payments.fields.ftCode": "Mã FT",
  "pages.bidvqr.payments.fields.ftCode.tips": "Mã ftCode, phục vụ đối soát và hoàn tiền sau này",
  "pages.bidvqr.payments.fields.notice": "Ghi chú",
  "pages.bidvqr.payments.fields.payDate": "Ngày thanh toán",
  "pages.bidvqr.payments.fields.qrPercentage": "Phí % QR",
  "pages.bidvqr.payments.fields.referenceLabelCode": "Mã giao dịch BIDV",
  "pages.bidvqr.payments.fields.referenceLabelCode.tips": "Mã giao dịch gửi sang BIDV",
  "pages.bidvqr.payments.fields.refundAmount": "Số tiền hoàn",
  "pages.bidvqr.payments.fields.status": "Trạng thái",
  "pages.bidvqr.payments.fields.terminalID": "Mã cổng",
  "pages.bidvqr.payments.fields.terminalID.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và BIDV",
  "pages.bidvqr.payments.fields.terminalName": "Tên cổng TT",
  "pages.bidvqr.payments.fields.terminalName.tips": "Mã nhà xe, hoặc tên cổng thanh toán",
  "pages.bidvqr.payments.fields.traceTransfer": "Số trace",
  "pages.bidvqr.payments.fields.traceTransfer.tips": "Số trace của hệ thống bank, do hệ thống bank tự sinh",
  "pages.bidvqr.payments.fields.transactionAmount": "Số tiền",
  "pages.bidvqr.payments.title": "Giao dịch thanh toán BIDV",
  "pages.bidvqr.refund.field.createdAt": "Ngày hoàn tiền",
  "pages.bidvqr.refund.fields.amount": "Số tiền",
  "pages.bidvqr.refund.fields.billNumber": "Mã giao dịch",
  "pages.bidvqr.refund.fields.billNumber.tips": "Mã giao dịch được hoàn của AV",
  "pages.bidvqr.refund.fields.ftCode": "Mã FT",
  "pages.bidvqr.refund.fields.ftCode.tips": "Mã ftCode giao dịch hoàn tiền",
  "pages.bidvqr.refund.fields.terminalID": "Mã cổng",
  "pages.bidvqr.refund.fields.terminalID.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và BIDV",
  "pages.bidvqr.refund.fields.traceTransfer": "Số trace",
  "pages.bidvqr.refund.fields.traceTransfer.tips": "Số trace của giao dịch được hoàn",
  "pages.bidvqr.refund.title": "Giao dịch hoàn tiền",
  "pages.bidvqr.terminals.actions.approve": "Phê duyệt",
  "pages.bidvqr.terminals.actions.deny": "Từ chối",
  "pages.bidvqr.terminals.button.batchApprove": "Phê duyệt hàng loạt",
  "pages.bidvqr.terminals.button.batchDeny": "Từ chối hàng loạt",
  "pages.bidvqr.terminals.field.createdAt": "Ngày tạo",
  "pages.bidvqr.terminals.fields.bankAccountName": "Tên tài khoản",
  "pages.bidvqr.terminals.fields.bankAccountNumber": "Số tài khoản",
  "pages.bidvqr.terminals.fields.identityNumber": "Số CCCD/CMT",
  "pages.bidvqr.terminals.fields.phoneNo": "Số điện thoại",
  "pages.bidvqr.terminals.fields.qrPercentage": "Phí giao dịch",
  "pages.bidvqr.terminals.fields.serviceId": "Service ID",
  "pages.bidvqr.terminals.fields.serviceId.tips": "Service Id của doanh nghiệp do BIDV cấp",
  "pages.bidvqr.terminals.fields.status": "Trạng thái",
  "pages.bidvqr.terminals.fields.terminalId": "Mã cổng",
  "pages.bidvqr.terminals.fields.terminalId.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và BIDV",
  "pages.bidvqr.terminals.fields.terminalName": "Tên cổng TT",
  "pages.bidvqr.terminals.fields.terminalName.tips": "ID định danh của đối tác, mã nhà xe, mã khách hàng",
  "pages.bidvqr.terminals.newForm.title": "Đăng ký tài khoản doanh nghiệp",
  "pages.bidvqr.terminals.table.footerText": "| Chờ phê duyệt: {pending} | Bị từ chối: {deny}",
  "pages.bidvqr.terminals.table.title": "Danh sách cổng thanh toán BIDV QR",
  "pages.bidvqr.terminals.updateForm.title": "Cập nhật cổng thanh toán BIDV QR",
  "pages.brandname.addForm.title": "Thêm SMS thương hiệu",
  "pages.brandname.detailForm.title": "Thông tin chi tiết SMS thương hiệu",
  "pages.brandname.fields.alias": "Alias",
  "pages.brandname.fields.clientId": "Client Id",
  "pages.brandname.fields.clientSecretKey": "Client Secret Key",
  "pages.brandname.fields.companyId": "Nhà xe",
  "pages.brandname.fields.companyStatus": "Trạng thái nhà xe",
  "pages.brandname.fields.createdAt": "Ngày tạo",
  "pages.brandname.fields.eContractFeeType": "Cách tính giá HĐĐT",
  "pages.brandname.fields.isPrivate": "Không tính phí",
  "pages.brandname.fields.password": "Mật khẩu",
  "pages.brandname.fields.paymentTypes": "Phương thức thanh toán (paymentTypes)",
  "pages.brandname.fields.serviceSupporter": "Đơn vị cung cấp",
  "pages.brandname.fields.useOtpAnVui": "Sử dụng OTP An Vui",
  "pages.brandname.fields.user": "Tên tài khoản",
  "pages.brandname.table.title": "Danh sách SMS thương hiệu",
  "pages.brandname_partner.fields.companyId": "Đối tác",
  "pages.brandname_partner.fields.version": "API Version",
  "pages.brandname_partner_partner.fields.companyId": "Đối tác",
  "pages.client.actions.resetClientSecret": "Tạo lại mã bí mật",
  "pages.client.detailForm.title": "Thông tin đối tác",
  "pages.client.fields.active": "Trạng thái",
  "pages.client.fields.clientId": "Mã đối tác (client id)",
  "pages.client.fields.clientId.placeholder": "Vui lòng nhập Mã đối tác",
  "pages.client.fields.clientSecret": "Mã bí mật (client secret)",
  "pages.client.fields.clientSecret.placeholder": "Vui lòng nhập Mã bí mật",
  "pages.client.fields.clientSecret.required": "Hãy nhập mã bí mật!",
  "pages.client.fields.name": "Tên đối tác tích hợp",
  "pages.client.newForm.title": "Thêm mới đối tác tích hợp",
  "pages.client.resetClientSecretForm.newClientSecret": "Mã bí mật mới",
  "pages.client.resetClientSecretForm.title": "Tạo lại mã bí mật",
  "pages.client.table.title": "Danh sách đối tác tích hợp",
  "pages.client.tips.clientId": "Mã đối tác là duy nhất",
  "pages.client.updateForm.title": "Cập nhật đối tác tích hợp",
  "pages.cloud_speaker.detailForm.title": "Thông tin loa thanh toán",
  "pages.cloud_speaker.fields.isActive": "Trạng thái",
  "pages.cloud_speaker.fields.paymentGateway": "Cổng thanh toán",
  "pages.cloud_speaker.fields.serial": "Mã thiết bị",
  "pages.cloud_speaker.fields.serial.placeholder": "Vui lòng nhập Mã thiết bị",
  "pages.cloud_speaker.fields.serial.tips": "Mã thiết bị là duy nhất",
  "pages.cloud_speaker.fields.terminalId": "Mã cổng thanh toán",
  "pages.cloud_speaker.fields.terminalId.placeholder": "Vui lòng nhập Mã cổng thanh toán",
  "pages.cloud_speaker.newForm.title": "Thêm mới loa thanh toán",
  "pages.cloud_speaker.table.title": "Danh sách loa thanh toán",
  "pages.cloud_speaker.updateForm.title": "Cập nhật loa thanh toán",
  "pages.common.option": "Thao tác",
  "pages.common.view": "Xem",
  "pages.company-services-used.error.fetch": "Lỗi lấy dữ liệu báo cáo",
  "pages.company-services-used.fields.companyId": "Mã nhà xe",
  "pages.company-services-used.fields.companyName": "Nhà xe",
  "pages.company-services-used.fields.departureCount": "Số lượt XB",
  "pages.company-services-used.fields.departureFee": "Phí xuất bến",
  "pages.company-services-used.fields.departureRemaining": "Số chuyến XB còn lại",
  "pages.company-services-used.fields.deposit": "Nạp tiền TK",
  "pages.company-services-used.fields.depositCount": "Số lần nạp",
  "pages.company-services-used.fields.depositDecrease": "Số tiền giảm",
  "pages.company-services-used.fields.depositIncrease": "Số tiền tăng",
  "pages.company-services-used.fields.depositPromotion": "Số tiền khuyến mãi",
  "pages.company-services-used.fields.lvcdtRemaining": "LVCĐT còn lại",
  "pages.company-services-used.fields.monthlyServiceFee": "Phí dịch vụ PM hàng tháng",
  "pages.company-services-used.fields.monthlySwitchboardFee": "Phí tổng đài hàng tháng",
  "pages.company-services-used.fields.smsBrandnameFee": "Phí Brandname",
  "pages.company-services-used.fields.znsSubscriptionFee": "Phí thuê bao",
  "pages.company-services-used.title": "Tổng hợp dịch vụ nhà xe sử dụng",
  "pages.company-services.error.fetch": "Lỗi lấy danh sách dịch vụ nhà xe",
  "pages.company-services.fields.amount": "Số tiền",
  "pages.company-services.fields.balanceType": "Loại dịch vụ",
  "pages.company-services.fields.companyId": "Nhà xe",
  "pages.company-services.fields.companyName": "Tên công ty",
  "pages.company-services.fields.description": "Mô tả",
  "pages.company-services.fields.payDateInMillisec": "Ngày giờ thực hiện",
  "pages.company-services.fields.userName": "Nhân viên thực hiện",
  "pages.company-services.title": "Tổng hợp dịch vụ nhà xe",
  "pages.company.actions.changeAccountBalance": "Thay đổi số dư tài khoản",
  "pages.company.changeAccountBalance.fields.amount": "Số tiền",
  "pages.company.changeAccountBalance.fields.amount.placeholder": "Nhập số tiền",
  "pages.company.changeAccountBalance.fields.amount.required": "Vui lòng nhập Số tiền",
  "pages.company.changeAccountBalance.fields.description": "Nội dung",
  "pages.company.changeAccountBalance.fields.description.placeholder": "Nhập nội dung",
  "pages.company.changeAccountBalance.fields.description.required": "Vui lòng nhập nội dung",
  "pages.company.changeAccountBalance.fields.option": "Tùy chọn",
  "pages.company.changeAccountBalance.fields.option.initializationFee": "Trừ tiền Phí khởi tạo",
  "pages.company.changeAccountBalance.fields.option.wallet": "Trừ tiền ví",
  "pages.company.changeAccountBalance.fields.promotionAmount": "Số tiền khuyến mãi",
  "pages.company.changeAccountBalance.fields.promotionAmount.placeholder": "Nhập số tiền khuyến mãi",
  "pages.company.changeAccountBalance.fields.type": "Loại",
  "pages.company.changeAccountBalance.fields.type.decrease": "Giảm",
  "pages.company.changeAccountBalance.fields.type.increase": "Tăng",
  "pages.company.changeAccountBalance.title": "Thay đổi số dư tài khoản",
  "pages.company.configApp.fields.androidGoogleInfo": "androidGoogleInfo",
  "pages.company.configApp.fields.androidGoogleInfo.placeholder": "androidGoogleInfo",
  "pages.company.configApp.fields.androidLogo": "Logo Android (androidLogo)",
  "pages.company.configApp.fields.androidLogo.placeholder": "androidLogo",
  "pages.company.configApp.fields.cancelPolicyLink": "Link chính sách hủy (cancelPolicyLink)",
  "pages.company.configApp.fields.cancelPolicyLink.placeholder": "cancelPolicyLink",
  "pages.company.configApp.fields.companyLogo": "Logo công ty (companyLogo)",
  "pages.company.configApp.fields.companyLogo.placeholder": "companyLogo",
  "pages.company.configApp.fields.companyMITLink": "Company MIT Link (companyMITLink)",
  "pages.company.configApp.fields.companyMITLink.placeholder": "companyMITLink",
  "pages.company.configApp.fields.companyName": "Tên công ty",
  "pages.company.configApp.fields.companyName.placeholder": "Vui lòng nhập Tên công ty",
  "pages.company.configApp.fields.dataConfig": "dataConfig",
  "pages.company.configApp.fields.dataConfig.placeholder": "dataConfig",
  "pages.company.configApp.fields.firebaseConfig": "FirebaseConfig",
  "pages.company.configApp.fields.firebaseConfig.placeholder": "Firebase Config",
  "pages.company.configApp.fields.firebaseProjectId": "Firebase ProjectId",
  "pages.company.configApp.fields.firebaseProjectId.placeholder": "Firebase ProjectId",
  "pages.company.configApp.fields.folderName": "folderName",
  "pages.company.configApp.fields.folderName.placeholder": "folderName",
  "pages.company.configApp.fields.footer": "Footer (footer)",
  "pages.company.configApp.fields.footer.placeholder": "footer",
  "pages.company.configApp.fields.googleMapKey": "googleMapKey",
  "pages.company.configApp.fields.googleMapKey.placeholder": "googleMapKey",
  "pages.company.configApp.fields.hotline": "Tổng đài hỗ trợ",
  "pages.company.configApp.fields.hotline.placeholder": "hotline",
  "pages.company.configApp.fields.iosGoogleInfo": "iosGoogleInfo",
  "pages.company.configApp.fields.iosGoogleInfo.placeholder": "iosGoogleInfo",
  "pages.company.configApp.fields.iosLogo": "Logo IOS (iosLogo)",
  "pages.company.configApp.fields.iosLogo.placeholder": "iosLogo",
  "pages.company.configApp.fields.keyStore": "KeyStore (keyStore)",
  "pages.company.configApp.fields.keyStore.placeholder": "keyStore",
  "pages.company.configApp.fields.loginType": "Phương thức đăng nhập (loginType)",
  "pages.company.configApp.fields.packageName": "Package Name (packageName)",
  "pages.company.configApp.fields.packageName.placeholder": "packageName",
  "pages.company.configApp.fields.paymentPolicyLink": "Link chính sách thanh toán (paymentPolicyLink)",
  "pages.company.configApp.fields.paymentPolicyLink.placeholder": "paymentPolicyLink",
  "pages.company.configApp.fields.primaryColor": "primaryColor",
  "pages.company.configApp.fields.primaryColor.placeholder": "primaryColor",
  "pages.company.configApp.fields.primaryColorDark": "primaryColorDark",
  "pages.company.configApp.fields.primaryColorDark.placeholder": "primaryColorDark",
  "pages.company.configApp.fields.privacyPolicyLink": "Link điều khoản thanh toán (privacyPolicyLink)",
  "pages.company.configApp.fields.privacyPolicyLink.placeholder": "privacyPolicyLink",
  "pages.company.configApp.fields.ticketDeliveryPolicyLink": "Link chính sách giao hàng (ticketDeliveryPolicyLink)",
  "pages.company.configApp.fields.ticketDeliveryPolicyLink.placeholder": "ticketDeliveryPolicyLink",
  "pages.company.configApp.fields.ticketReturnPolicyLink": "Link chính sách hoàn (ticketReturnPolicyLink)",
  "pages.company.configApp.fields.ticketReturnPolicyLink.placeholder": "ticketReturnPolicyLink",
  "pages.company.configApp.fields.urlIntro": "Link giới thiệu (urlIntro)",
  "pages.company.configApp.fields.urlIntro.placeholder": "urlIntro",
  "pages.company.configApp.fields.urlTerm": "Link Điều khoản (urlTerm)",
  "pages.company.configApp.fields.urlTerm.placeholder": "urlTerm",
  "pages.company.configApp.title": "Cấu hình App nhà xe",
  "pages.company.configFee.aiBooking.channels.title": "Cấu hình Kênh",
  "pages.company.configFee.aiBooking.resources.title": "Cấu hình Tài nguyên",
  "pages.company.configFee.aiBooking.title": "Cấu hình AI Booking",
  "pages.company.configFee.createOrderPrice.tripFee": "Giá tạo (vé/đơn hàng)",
  "pages.company.configFee.emailFee.tripFee": "Giá gửi email",
  "pages.company.configFee.fields.AICommissionFee": "Phí dịch vụ trên mỗi vé",
  "pages.company.configFee.fields.AICommissionFee.placeholder": "Nhập phí dịch vụ trên mỗi vé",
  "pages.company.configFee.fields.AICommissionType": "Loại phí",
  "pages.company.configFee.fields.AIMonthlyFee": "Phí dịch vụ hàng tháng",
  "pages.company.configFee.fields.AIMonthlyFee.placeholder": "Nhập phí dịch vụ hàng tháng",
  "pages.company.configFee.fields.appDeviceSellTicketFee": "Phí kích hoạt App bán vé",
  "pages.company.configFee.fields.appDeviceSellTicketFee.placeholder": "Vui lòng nhập Phí kích hoạt App bán vé",
  "pages.company.configFee.fields.appDeviceSubDriverFee": "Phí kích hoạt App phụ xe",
  "pages.company.configFee.fields.appDeviceSubDriverFee.placeholder": "Vui lòng nhập Phí kích hoạt App phụ xe",
  "pages.company.configFee.fields.companyName": "Tên công ty",
  "pages.company.configFee.fields.companyName.placeholder": "Vui lòng nhập Tên công ty",
  "pages.company.configFee.fields.createOrderPrice.placeholder": "Vui lòng nhập Giá tạo (vé/đơn hàng)",
  "pages.company.configFee.fields.eContractPrice": "Giá xuất HĐĐT (VNĐ)",
  "pages.company.configFee.fields.eContractPrice.placeholder": "Vui lòng nhập Giá xuất HĐĐT (VNĐ)",
  "pages.company.configFee.fields.emailFee.placeholder": "Vui lòng nhập Giá gửi email",
  "pages.company.configFee.fields.enableCallcenterChannel": "Kích hoạt AI Tổng đài",
  "pages.company.configFee.fields.enableCallcenterChannel.tooltip": "Ghi nhận nhà xe đã tích hợp AI vào tổng đài (Voicebot), phục vụ thông tin & báo cáo; hệ thống tổng đài do bên thứ ba xử lý nên cờ này không điều khiển luồng gọi thực tế.",
  "pages.company.configFee.fields.enableChatbotChannel": "Kích hoạt AI ChatBot",
  "pages.company.configFee.fields.enableChatbotChannel.tooltip": "Cho phép tính năng AI Booking hiển thị và hoạt động trên Website/Widget do An Vui cung cấp cho nhà xe.",
  "pages.company.configFee.fields.hideSeatMap.placeholder": "Ẩn sơ đồ ghế",
  "pages.company.configFee.fields.isTesting.placeholder": "Nhà xe testing",
  "pages.company.configFee.fields.lockCompanyByBalance.placeholder": "Khóa tài khoản khi số dư ví âm",
  "pages.company.configFee.fields.maxConcurrentSessions": "Số lượng Bot phục vụ đồng thời",
  "pages.company.configFee.fields.maxConcurrentSessions.placeholder": "Tối thiểu 1",
  "pages.company.configFee.fields.maxConcurrentSessions.tooltip": "Giới hạn số khách hàng AI ChatBot có thể đáp ứng đồng thời. Chỉ áp dụng cho kênh ChatBot.",
  "pages.company.configFee.fields.monthlyServiceFee.placeholder": "Vui lòng nhập Phí dịch vụ PM theo tháng",
  "pages.company.configFee.fields.numberFreeDeviceSellTicket": "Số lượng KH App Sale miễn phí",
  "pages.company.configFee.fields.numberFreeDeviceSellTicket.placeholder": "Vui lòng nhập Số lượng KH App Sale miễn phí",
  "pages.company.configFee.fields.numberFreeDeviceSubDriver": "Số lượng App Driver miễn phí",
  "pages.company.configFee.fields.numberFreeDeviceSubDriver.placeholder": "Vui lòng nhập Số lượng App Driver miễn phí",
  "pages.company.configFee.fields.otpMethod": "Phương thức gửi tin nhắn OTP",
  "pages.company.configFee.fields.smsPrice": "Giá tin nhắn (VNĐ)",
  "pages.company.configFee.fields.smsPrice.placeholder": "Vui lòng nhập Giá tin nhắn (VNĐ)",
  "pages.company.configFee.fields.telecomFee.placeholder": "Vui lòng nhập Phí tổng đài",
  "pages.company.configFee.fields.ticketEcontractFee.placeholder": "Vui lòng nhập Phí vé điện tử (VNĐ)",
  "pages.company.configFee.fields.transitWithAnvuiEnabled.placeholder": "Cho phép trung chuyển với Anvui",
  "pages.company.configFee.fields.transportPrice.placeholder": "Vui lòng nhập Phí lệnh vận chuyển điện tử",
  "pages.company.configFee.fields.tripFee": "Phí xuất bến (VNĐ)",
  "pages.company.configFee.fields.tripFee.placeholder": "Vui lòng nhập Phí xuất bến (VNĐ)",
  "pages.company.configFee.fields.zaloOaFee.placeholder": "Vui lòng nhập Phí thuê bao ZNS theo tháng",
  "pages.company.configFee.fields.zaloOaPrice.placeholder": "Vui lòng nhập Phí thuê bao ZNS theo tin nhắn",
  "pages.company.configFee.monthlyServiceFee.tripFee": "Phí dịch vụ PM theo tháng",
  "pages.company.configFee.telecomFee.tripFee": "Phí tổng đài",
  "pages.company.configFee.ticketEcontractFee.tripFee": "Phí vé điện tử (VNĐ)",
  "pages.company.configFee.title": "Chỉnh sửa giá dịch vụ",
  "pages.company.configFee.transportPrice.tripFee": "Phí lệnh vận chuyển điện tử",
  "pages.company.configFee.zaloOaFee.tripFee": "Phí thuê bao ZNS theo tháng",
  "pages.company.configFee.zaloOaPrice.tripFee": "Phí thuê bao ZNS theo tin nhắn",
  "pages.company.detailForm.title": "Thông tin chi tiết nhà xe",
  "pages.company.fields.amountPromotion": "Khuyến mãi",
  "pages.company.fields.billNumber": "Mã giao dịch",
  "pages.company.fields.chargeNote": "Nội dung",
  "pages.company.fields.companyId": "ID nhà xe",
  "pages.company.fields.companyName": "Tên nhà xe",
  "pages.company.fields.depositAmount": "Số tiền nạp",
  "pages.company.fields.depositType": "Cách nạp tiền",
  "pages.company.fields.id": "Mã nhà xe",
  "pages.company.fields.id.tips": "Mã nhà xe là duy nhất",
  "pages.company.fields.initializationFee": "Phí khởi tạo",
  "pages.company.fields.monthlyServiceFee": "Phí PM theo tháng",
  "pages.company.fields.note": "Ghi chú",
  "pages.company.fields.numberFreeTransport": "Gói LVC còn lại",
  "pages.company.fields.numberFreeTrip": "Gói XB còn lại",
  "pages.company.fields.otherFee": "Doanh thu khác",
  "pages.company.fields.qrPercentage": "Phí giao dịch QR",
  "pages.company.fields.smsPrice": "Phí SMS",
  "pages.company.fields.telecomFee": "Phí tổng đài",
  "pages.company.fields.transferFee": "Phí trung chuyển",
  "pages.company.fields.transportPrice": "Phí LVC",
  "pages.company.fields.tripFee": "Phí XB",
  "pages.company.fields.vietqrFee": "Phí VietQR",
  "pages.company.fields.walletAmount": "Số dư ví",
  "pages.company.registerWeb.fail": "Đăng ký website nhà xe thất bại",
  "pages.company.registerWeb.fields.phoneNumber": "Số điện thoại",
  "pages.company.registerWeb.fields.phoneNumber.placeholder": "Vui lòng nhập Số điện thoại",
  "pages.company.registerWeb.fields.subDomain": "Sub Domain",
  "pages.company.registerWeb.fields.subDomain.placeholder": "Vui lòng nhập sub domain website",
  "pages.company.registerWeb.fields.userId.placeholder": "Vui lòng nhập User đăng nhập",
  "pages.company.registerWeb.title": "Đăng ký website nhà xe",
  "pages.company.table.title": "Danh sách nhà xe",
  "pages.company.updateMenuForm.menu": "Chọn gói menu",
  "pages.companyAccount.actions.hasAdmin": "Tài khoản đã có quyền Quản trị (Admin)",
  "pages.companyAccount.actions.resetPassword": "Đặt lại mật khẩu",
  "pages.companyAccount.actions.setAdmin": "Thêm quyền Quản trị (Admin)",
  "pages.companyAccount.fields.company": "Chọn nhà xe",
  "pages.companyAccount.fields.fullName": "Họ và tên",
  "pages.companyAccount.fields.phoneNumber": "Số điện thoại",
  "pages.companyAccount.fields.userName": "Tài khoản",
  "pages.companyAccount.fields.userType": "Loại tài khoản",
  "pages.companyAccount.modal.resetPassword.confirm": "Bạn có chắc chắn muốn đặt lại mật khẩu?",
  "pages.companyAccount.modal.setAdmin.confirm": "Bạn có chắc chắn muốn thay đổi quyền tài khoản?",
  "pages.companyAccount.table.title": "Danh sách tài khoản nhà xe",
  "pages.companyPartner.addStaff.fullName.label": "Họ & tên",
  "pages.companyPartner.addStaff.fullName.placeholder": "Nhập họ & tên",
  "pages.companyPartner.addStaff.password.label": "Mật khẩu",
  "pages.companyPartner.addStaff.password.placeholder": "Nhập mật khẩu",
  "pages.companyPartner.addStaff.role.label": "Vai trò",
  "pages.companyPartner.addStaff.role.placeholder": "Nhập Admin hoặc Staff",
  "pages.companyPartner.addStaff.userName.label": "Tên đăng nhập",
  "pages.companyPartner.addStaff.userName.placeholder": "Nhập tên đăng nhập",
  "pages.companyPartner.deposit.amount.label": "Số tiền",
  "pages.companyPartner.deposit.amount.placeholder": "Nhập số tiền",
  "pages.companyPartner.deposit.note.label": "Ghi chú",
  "pages.companyPartner.deposit.note.placeholder": "Nhập nội dung ghi chú",
  "pages.companyPartner.fields.balance": "Số dư",
  "pages.companyPartner.fields.isAIPartner": "Đối tác AI",
  "pages.companyPartner.fields.name": "Tên đối tác",
  "pages.companyPartner.fields.name.placeholder": "Nhập tên đối tác...",
  "pages.companyPartner.fields.partnerCompanies": "Nhà xe",
  "pages.companyPartner.fields.role": "Vai trò",
  "pages.companyPartner.table.title": "Danh sách đối tác",
  "pages.companyPayment.button.createPayment": "Tạo giao dịch",
  "pages.companyZaloOaAccount.fields.appId": "App Id",
  "pages.companyZaloOaAccount.fields.appSecret": "App Secret",
  "pages.companyZaloOaAccount.fields.companyName": "Nhà xe",
  "pages.companyZaloOaAccount.fields.filterType": "Lọc theo",
  "pages.companyZaloOaAccount.fields.filterType.company": "Nhà xe",
  "pages.companyZaloOaAccount.fields.filterType.partner": "Đại lý",
  "pages.companyZaloOaAccount.fields.pageId": "Page Id",
  "pages.companyZaloOaAccount.fields.partnerName": "Đại lý",
  "pages.companyZaloOaAccount.fields.password": "Password",
  "pages.companyZaloOaAccount.fields.price": "Giá",
  "pages.companyZaloOaAccount.fields.provider": "Đơn vị cung cấp",
  "pages.companyZaloOaAccount.fields.status": "Hoạt động",
  "pages.companyZaloOaAccount.fields.status.all": "Tất cả trạng thái",
  "pages.companyZaloOaAccount.fields.user": "Username",
  "pages.companyZaloOaAccount.modal.remove.confirm": "Bạn có chắc chắn muốn xóa tài khoản ZaloOA này?",
  "pages.companyZaloOaAccount.newForm.title": "Thêm tài khoản ZaloOA",
  "pages.companyZaloOaAccount.table.title": "Cấu hình tài khoản Zalo OA",
  "pages.companyZaloOaAccount.updateForm.title": "Cập nhật tài khoản ZaloOA",
  "pages.config.news.addForm.title": "Thêm tin tức",
  "pages.config.news.editForm.title": "Chỉnh sửa tin tức",
  "pages.config.news.fields.id": "ID",
  "pages.config.news.fields.lang": "Ngôn ngữ",
  "pages.config.news.fields.title": "Tin tức",
  "pages.config.news.form.content": "Nội dung",
  "pages.config.news.form.desc": "Description",
  "pages.config.news.form.img": "Ảnh bài viết",
  "pages.config.news.form.is_show_on_login": "Hiển thị trên trang đăng nhập Quản trị Nhà xe",
  "pages.config.news.form.lang": "Ngôn ngữ",
  "pages.config.news.form.meta_description": "Meta description",
  "pages.config.news.form.meta_keyword": "Meta Keyword",
  "pages.config.news.form.meta_title": "Meta Title",
  "pages.config.news.form.status": "Trạng thái",
  "pages.config.news.form.title": "Tên bài viết",
  "pages.config.news.page.title": "Danh sách tin tức",
  "pages.config.recruit.addForm.title": "Thêm tin tuyển dụng",
  "pages.config.recruit.fields.id": "ID",
  "pages.config.recruit.fields.lang": "Ngôn ngữ",
  "pages.config.recruit.fields.place": "Khu vực",
  "pages.config.recruit.fields.salary": "Mức lương",
  "pages.config.recruit.fields.title": "Tiêu đề",
  "pages.config.recruit.form.content": "Nội dung",
  "pages.config.recruit.form.dateRange": "Ngày tuyển dụng",
  "pages.config.recruit.form.img": "Ảnh tin tuyển dụng",
  "pages.config.recruit.form.lang": "Ngôn ngữ",
  "pages.config.recruit.form.place": "Khu vực",
  "pages.config.recruit.form.salary": "Mức lương (tr)",
  "pages.config.recruit.form.status": "Trạng thái",
  "pages.config.recruit.form.title": "Tiêu đề",
  "pages.config.recruit.page.title": "Danh sách tin tuyển dụng",
  "pages.contact.info.button.add": "Thêm liên hệ",
  "pages.contact.info.button.save": "Lưu",
  "pages.contact.info.fields.address": "Địa chỉ",
  "pages.contact.info.fields.email": "Email",
  "pages.contact.info.fields.facebook": "Facebook",
  "pages.contact.info.fields.fullName": "Họ và tên",
  "pages.contact.info.fields.phoneNumber": "Số điện thoại",
  "pages.contact.info.fields.position": "Chức vụ",
  "pages.contact.info.fields.skype": "Skype",
  "pages.contact.info.fields.website": "Website",
  "pages.contact.info.table.title": "Danh sách liên hệ",
  "pages.coordination.history.expand.company.name": "Nhà xe",
  "pages.coordination.history.expand.customer.info": "Thông tin khách",
  "pages.coordination.history.expand.dropoff.info": "TRẢ KHÁCH",
  "pages.coordination.history.expand.pickup.info": "ĐÓN KHÁCH",
  "pages.coordination.history.expand.start_time": "Giờ xe khách đi / đến",
  "pages.coordination.history.expandDetail.companyId": "ID Nhà xe",
  "pages.coordination.history.expandDetail.companyName": "Tên nhà xe",
  "pages.coordination.history.expandDetail.createdAt": "Ngày tạo vé",
  "pages.coordination.history.expandDetail.dropoffAddress": "Địa chỉ trả",
  "pages.coordination.history.expandDetail.dropoffLatitude": "Vĩ độ trả",
  "pages.coordination.history.expandDetail.dropoffLongitude": "Kinh độ trả",
  "pages.coordination.history.expandDetail.dropoffName": "Tên điểm trả",
  "pages.coordination.history.expandDetail.dropoffProvinceId": "Tỉnh trả",
  "pages.coordination.history.expandDetail.dropoffProvinceName": "Tên tỉnh trả",
  "pages.coordination.history.expandDetail.dropoffWardName": "Phường/Xã trả",
  "pages.coordination.history.expandDetail.estDistance": "Khoảng cách dự tính (km)",
  "pages.coordination.history.expandDetail.estPickupTime": "Thời gian đón dự tính",
  "pages.coordination.history.expandDetail.fullName": "Tên khách",
  "pages.coordination.history.expandDetail.isArranged": "Đã sắp xếp",
  "pages.coordination.history.expandDetail.isDeleted": "Đã xóa",
  "pages.coordination.history.expandDetail.note": "Ghi chú vé",
  "pages.coordination.history.expandDetail.ordererPhoneNumber": "SĐT người đặt",
  "pages.coordination.history.expandDetail.phoneNumber": "SĐT khách",
  "pages.coordination.history.expandDetail.pickupAddress": "Địa chỉ đón",
  "pages.coordination.history.expandDetail.pickupLatitude": "Vĩ độ đón",
  "pages.coordination.history.expandDetail.pickupLongitude": "Kinh độ đón",
  "pages.coordination.history.expandDetail.pickupName": "Tên điểm đón",
  "pages.coordination.history.expandDetail.pickupProvinceId": "Tỉnh đón",
  "pages.coordination.history.expandDetail.pickupProvinceName": "Tên tỉnh đón",
  "pages.coordination.history.expandDetail.pickupWardName": "Phường/Xã đón",
  "pages.coordination.history.expandDetail.pointDirection": "Hướng tuyến",
  "pages.coordination.history.expandDetail.routeId": "ID Tuyến",
  "pages.coordination.history.expandDetail.sex": "Giới tính",
  "pages.coordination.history.expandDetail.tags": "Tags",
  "pages.coordination.history.expandDetail.ticketCode": "Mã vé",
  "pages.coordination.history.expandDetail.ticketId": "ID Vé",
  "pages.coordination.history.expandDetail.ticketStatus": "Trạng thái vé",
  "pages.coordination.history.expandDetail.transitTransaction": "Thông tin giao dịch vận chuyển",
  "pages.coordination.history.expandDetail.updatedAt": "Ngày cập nhật vé",
  "pages.coordination.history.fields.actions": "Hành động",
  "pages.coordination.history.fields.addonsFee": "Phí bổ sung",
  "pages.coordination.history.fields.baseFee": "Phí cơ bản",
  "pages.coordination.history.fields.boardingTime": "Thời gian lên xe",
  "pages.coordination.history.fields.companyId": "Nhà xe",
  "pages.coordination.history.fields.createdAt": "Ngày tạo",
  "pages.coordination.history.fields.createdBy": "Người tạo",
  "pages.coordination.history.fields.deepLink": "Deep link",
  "pages.coordination.history.fields.distance": "Khoảng cách (km)",
  "pages.coordination.history.fields.driverName": "Tên tài xế",
  "pages.coordination.history.fields.driverPhoneNumber": "SĐT tài xế",
  "pages.coordination.history.fields.duration": "Thời gian (phút)",
  "pages.coordination.history.fields.fee": "Phí nhà xe",
  "pages.coordination.history.fields.feeId": "ID phí",
  "pages.coordination.history.fields.isProduction": "Môi trường production",
  "pages.coordination.history.fields.note": "Ghi chú",
  "pages.coordination.history.fields.orderId": "Mã trung chuyển An Vui",
  "pages.coordination.history.fields.orderStatus": "Trạng thái",
  "pages.coordination.history.fields.orderTime": "Thời gian đặt",
  "pages.coordination.history.fields.partnerTripId": "Mã chuyến nhà xe",
  "pages.coordination.history.fields.paymentMethod": "Phương thức thanh toán",
  "pages.coordination.history.fields.requestInvoice": "Yêu cầu hóa đơn",
  "pages.coordination.history.fields.serviceId": "ID dịch vụ XanhSM",
  "pages.coordination.history.fields.serviceType": "Loại dịch vụ",
  "pages.coordination.history.fields.severity": "Mức độ Nghiêm trọng",
  "pages.coordination.history.fields.surcharge": "Phụ phí",
  "pages.coordination.history.fields.traceId": "Mã chuyến Đối tác",
  "pages.coordination.history.fields.updatedAt": "Ngày cập nhật",
  "pages.coordination.history.fields.vehicleCapacity": "Sức chứa xe",
  "pages.coordination.history.fields.vehicleColorName": "Màu xe",
  "pages.coordination.history.fields.vehicleLicensePlate": "Biển số xe",
  "pages.coordination.history.fields.vehicleModel": "Mẫu xe",
  "pages.coordination.history.fields.xanhsmTotalFee": "Phí Đối tác",
  "pages.coordination.history.update.addonsFee": "Phí bổ sung (VNĐ)",
  "pages.coordination.history.update.baseFee": "Phí cơ bản (VNĐ)",
  "pages.coordination.history.update.baseFee.error.cannot_reset_to_zero": "Phí cơ bản không thể đặt về 0 hoặc để trống khi đã có giá trị",
  "pages.coordination.history.update.baseFee.error.required_positive": "Phí cơ bản bắt buộc phải lớn hơn 0 với trạng thái này",
  "pages.coordination.history.update.deepLink": "Thông tin đơn theo dõi (Deep link)",
  "pages.coordination.history.update.distance": "Khoảng cách (km)",
  "pages.coordination.history.update.distance.error.cannot_reset_to_zero": "Khoảng cách không thể đặt về 0 hoặc để trống khi đã có giá trị",
  "pages.coordination.history.update.distance.error.required_positive": "Khoảng cách bắt buộc phải lớn hơn 0 với trạng thái này",
  "pages.coordination.history.update.driverName": "Tên tài xế",
  "pages.coordination.history.update.driverPhoneNumber": "Số điện thoại tài xế",
  "pages.coordination.history.update.duration": "Thời gian (phút)",
  "pages.coordination.history.update.error.has_service": "Không thể cập nhật đơn hàng đã có dịch vụ",
  "pages.coordination.history.update.note": "Ghi chú",
  "pages.coordination.history.update.note.error.required_for_completed": "Vui lòng nhập ghi chú khi trạng thái đơn là Hoàn thành",
  "pages.coordination.history.update.orderStatus": "Trạng thái",
  "pages.coordination.history.update.partnerBooking": "Đối tác đặt xe",
  "pages.coordination.history.update.subtitle": "Mã đơn hàng: {orderId}",
  "pages.coordination.history.update.surcharge": "Phụ phí (VNĐ)",
  "pages.coordination.history.update.title": "Cập nhật thông tin đơn hàng",
  "pages.coordination.history.update.totalFee": "Tổng phí (VNĐ)",
  "pages.coordination.history.update.traceId": "Trace ID",
  "pages.coordination.history.update.vehicleLicensePlate": "Biển số xe",
  "pages.coordination.history.update.warning.has_service": "Không thể cập nhật đơn hàng đã có dịch vụ (serviceId)",
  "pages.coordination.history.update.warning.readonly": "⚠️ Đơn hàng đã có dịch vụ, không thể chỉnh sửa",
  "pages.customer.actions.registerCompany": "Đăng ký tài khoản nhà xe",
  "pages.customer.addForm.address": "Địa chỉ",
  "pages.customer.addForm.address.placeholder": "Vui lòng nhập địa chỉ",
  "pages.customer.addForm.code": "Mã khách hàng",
  "pages.customer.addForm.code.placeholder": "Vui lòng nhập Mã khách hàng",
  "pages.customer.addForm.companyid": "Nhà xe",
  "pages.customer.addForm.customerStatus": "Trạng thái chăm sóc",
  "pages.customer.addForm.customerType": "Loại khách hàng",
  "pages.customer.addForm.list.admin.sale": "Admin Sale",
  "pages.customer.addForm.list.admin.sale.placeholder": "Vui lòng chọn Admin Sale",
  "pages.customer.addForm.list.deployer": "Nhân viên triển khai",
  "pages.customer.addForm.list.deployer.placeholder": "Vui lòng chọn nhân viên triển khai",
  "pages.customer.addForm.list.marketer": "Nhân viên kinh doanh",
  "pages.customer.addForm.list.marketer.placeholder": "Vui lòng chọn nhân viên kinh doanh",
  "pages.customer.addForm.name": "Tên khách hàng",
  "pages.customer.addForm.name.placeholder": "Vui lòng nhập Tên khách hàng",
  "pages.customer.addForm.phoneNumber": "Số điện thoại",
  "pages.customer.addForm.phoneNumber.placeholder": "Vui lòng nhập Số điện thoại",
  "pages.customer.addForm.presenter": "Người đại diện",
  "pages.customer.addForm.presenter.placeholder": "Vui lòng nhập tên người đại diện",
  "pages.customer.addForm.step1": "Thông tin chung",
  "pages.customer.addForm.step2": "Nhân viên chăm sóc",
  "pages.customer.addForm.step3": "Thông tin liên hệ",
  "pages.customer.addForm.title": "Thêm mới khách hàng",
  "pages.customer.detailForm.title": "Thông tin chi tiết khách hàng",
  "pages.customer.editForm.title": "Chỉnh sửa khách hàng",
  "pages.customer.fields.active": "Trạng thái",
  "pages.customer.fields.code": "Mã khách hàng",
  "pages.customer.fields.code.tips": "Mã khách hàng là duy nhất",
  "pages.customer.fields.customerStatus": "Trạng thái chăm sóc",
  "pages.customer.fields.customerType": "Kiểu khách hàng",
  "pages.customer.fields.deployer": "NV Triển Khai",
  "pages.customer.fields.marketer": "NV Kinh Doanh",
  "pages.customer.fields.name": "Tên khách hàng",
  "pages.customer.fields.phoneNumber": "Số điện thoại",
  "pages.customer.fields.region": "Khu vực",
  "pages.customer.registerCompany.fields.menuPackage": "Gói chức năng",
  "pages.customer.registerCompany.fields.password": "Mật khẩu",
  "pages.customer.registerCompany.fields.password.placeholder": "Vui lòng nhập Mật khẩu",
  "pages.customer.registerCompany.fields.username": "Tên đăng nhập",
  "pages.customer.registerCompany.fields.username.placeholder": "Vui lòng nhập Tên đăng nhập",
  "pages.customer.registerCompany.title": "Đăng ký tài khoản nhà xe",
  "pages.customer.registerWeb.fields.userLoginId": "User đăng nhập",
  "pages.customer.status.addForm.title": "Thêm trạng thái khách hàng",
  "pages.customer.status.fields.active": "Trạng thái",
  "pages.customer.status.fields.id": "Mã trạng thái",
  "pages.customer.status.fields.id.tips": "Mã trạng thái là duy nhất",
  "pages.customer.status.fields.name": "Tên trạng thái",
  "pages.customer.status.fields.statusOrder": "Thứ tự",
  "pages.customer.status.table.title": "Danh sách trạng thái khách hàng",
  "pages.customer.table.title": "Danh sách khách hàng",
  "pages.customerLead.actions.registerCustomer": "Chuyển thành khách hàng tiềm năng",
  "pages.customerLead.addForm.title": "Thêm khách hàng mới",
  "pages.customerLead.fields.address": "Địa chỉ",
  "pages.customerLead.fields.companyName": "Tên công ty",
  "pages.customerLead.fields.compnayName": "Tên công ty",
  "pages.customerLead.fields.createdAt": "Ngày đăng ký",
  "pages.customerLead.fields.fullName": "Tên khách hàng",
  "pages.customerLead.fields.phoneNumber": "Điện thoại",
  "pages.customerLead.table.title": "Danh sách khách hàng mới",
  "pages.customerLead.updateForm.title": "Cập nhật khách hàng mới",
  "pages.dashboard.introduction.hideMenu.text": "Thu gọn danh sách tính năng để hiển thị nội dung nhiều hơn",
  "pages.dashboard.introduction.hideMenu.title": "Thu gọn",
  "pages.dashboard.introduction.languageButton.text": "Bạn có thể thay đổi ngôn ngữ hiển thị một cách linh hoạt",
  "pages.dashboard.introduction.languageButton.title": "Hỗ trợ đa ngôn ngữ",
  "pages.dashboard.introduction.noticeButton.text": "Tất cả các thông báo của hệ thống sẽ hiển thị ở cùng một nơi",
  "pages.dashboard.introduction.noticeButton.title": "Nhận thông báo mới nhất",
  "pages.dashboard.introduction.profileButton.text": "Bạn sẽ có thể xác định một số tùy chọn và đảm bảo thông tin của bạn là chính xác.",
  "pages.dashboard.introduction.profileButton.title": "Một khởi đầu tốt có thể là xem xét hồ sơ của bạn",
  "pages.dashboard.introduction.rightMenu.text": "Tại đây sẽ liệt kê tất cả các tính năng mà bạn có thể sử dụng.",
  "pages.dashboard.introduction.rightMenu.title": "Tất cả các tính năng ở cùng một nơi",
  "pages.data-sync.check.title": "Đồng bộ dữ liệu",
  "pages.data-sync.fields.dataSyncState": "Tình trạng dữ liệu",
  "pages.data-sync.fields.dateInt": "Ngày kiểm tra",
  "pages.data-sync.fields.objectAmountDelete": "Bị xóa",
  "pages.data-sync.fields.objectAmountInsert": "Thêm mới",
  "pages.data-sync.fields.objectAmountUpdate": "Chỉnh sửa",
  "pages.data-sync.fields.objectClass": "Đối tượng",
  "pages.data-sync.fields.startTime": "Thời gian",
  "pages.data-sync.table.title": "Danh sách đồng bộ dữ liệu",
  "pages.dynamicReport.button.rollback": "Khôi phục",
  "pages.dynamicReport.detail.title": "Chi tiết báo cáo",
  "pages.dynamicReport.fields.createdAt": "Ngày tạo",
  "pages.dynamicReport.fields.isActive": "Trạng thái báo cáo",
  "pages.dynamicReport.fields.reportCode": "Mã báo cáo",
  "pages.dynamicReport.fields.reportName": "Tên báo cáo",
  "pages.dynamicReport.fields.status": "Trạng thái",
  "pages.dynamicReport.fields.updatedAt": "Ngày cập nhật",
  "pages.dynamicReport.fields.version": "Phiên bản",
  "pages.dynamicReport.fields.version_description": "Mô tả thay đổi",
  "pages.dynamicReport.form.title": "Cấu hình báo cáo động",
  "pages.dynamicReport.modal.rollback.title": "Bạn có chắc chắn muốn khôi phục?",
  "pages.dynamicReport.tab.defaultParams.title": "Tham số mặc định",
  "pages.dynamicReport.tab.formConfig.title": "Cấu hình bộ lọc",
  "pages.dynamicReport.tab.reportPreview.title": "Thông tin và xem trước",
  "pages.dynamicReport.tab.sqlQuery.title": "SQL truy vấn",
  "pages.dynamicReport.tab.statisticSql.title": "SQL thống kê",
  "pages.dynamicReport.tab.tableConfig.title": "Cấu hình bảng",
  "pages.dynamicReport.table.title": "Dynamic Reports",
  "pages.feedback.detail.title": "Chi tiết phản hồi",
  "pages.feedback.fields.company": "Nhà xe",
  "pages.feedback.fields.content": "Nội dung",
  "pages.feedback.fields.createdAt": "Ngày tạo",
  "pages.feedback.fields.email": "Email",
  "pages.feedback.fields.fullName": "Người gửi",
  "pages.feedback.fields.phoneNumber": "SĐT",
  "pages.feedback.fields.type": "Loại",
  "pages.feedback.title": "Phản hồi nhà xe",
  "pages.invoice-config.actions.delete": "Xóa",
  "pages.invoice-config.add": "Thêm mới",
  "pages.invoice-config.columns.actions": "Hành động",
  "pages.invoice-config.columns.active": "Trạng thái",
  "pages.invoice-config.columns.companyId": "Tên công ty",
  "pages.invoice-config.columns.index": "STT",
  "pages.invoice-config.columns.isTest": "Môi trường",
  "pages.invoice-config.columns.serviceSupporter": "Đơn vị cung cấp",
  "pages.invoice-config.columns.tax": "Mã số thuế",
  "pages.invoice-config.columns.unitCode": "Đơn vị",
  "pages.invoice-config.columns.user": "Tên tài khoản",
  "pages.invoice-config.create.success": "Tạo cấu hình hóa đơn thành công",
  "pages.invoice-config.delete.error": "Xóa cấu hình hóa đơn thất bại",
  "pages.invoice-config.delete.success": "Xóa cấu hình hóa đơn thành công",
  "pages.invoice-config.environment.production": "Production",
  "pages.invoice-config.environment.test": "Test",
  "pages.invoice-config.form.IsInvoiceCalculatingMachine": "Vé điện tử cho máy tính tiền",
  "pages.invoice-config.form.account": "Người dùng",
  "pages.invoice-config.form.accountPassword": "Mật khẩu người dùng",
  "pages.invoice-config.form.addOwner": "Thêm mã chủ sở hữu",
  "pages.invoice-config.form.companyId": "Chọn nhà xe",
  "pages.invoice-config.form.merchantLink": "Link API",
  "pages.invoice-config.form.ownerList": "Danh sách mã chủ sở hữu",
  "pages.invoice-config.form.password": "Mật khẩu",
  "pages.invoice-config.form.serviceSupporter": "Đơn vị cung cấp",
  "pages.invoice-config.form.signDirect": "Ký trực tiếp",
  "pages.invoice-config.form.tax": "Tax",
  "pages.invoice-config.form.taxFee": "Tiền thuế VDT (%)",
  "pages.invoice-config.form.taxFeeInvoice": "Tiền thuế HĐ (%)",
  "pages.invoice-config.form.unitCode": "Đơn vị",
  "pages.invoice-config.form.user": "Tên tài khoản",
  "pages.invoice-config.modal.add": "Thêm cấu hình hóa đơn",
  "pages.invoice-config.modal.edit": "Sửa cấu hình hóa đơn",
  "pages.invoice-config.status.active": "Hoạt động",
  "pages.invoice-config.status.inactive": "Không hoạt động",
  "pages.invoice-config.table.title": "Danh sách cấu hình hóa đơn",
  "pages.invoice-config.update.success": "Cập nhật cấu hình hóa đơn thành công",
  "pages.lhv_partner.detailForm.title": "Thông tin thiết bị LHV Partner",
  "pages.lhv_partner.fields.active": "Trạng thái",
  "pages.lhv_partner.fields.bankAccountNumber": "Số TK ngân hàng",
  "pages.lhv_partner.fields.connected": "Kết nối",
  "pages.lhv_partner.fields.createdAt": "Ngày kích hoạt",
  "pages.lhv_partner.fields.deviceName": "Tên thiết bị",
  "pages.lhv_partner.fields.serial": "Mã thiết bị",
  "pages.lhv_partner.fields.serial.tips": "Mã thiết bị là duy nhất",
  "pages.lhv_partner.fields.storeName": "Tên cửa hàng",
  "pages.lhv_partner.fields.terminalID": "Số TK định danh",
  "pages.lhv_partner.fields.totalAmount": "Tổng doanh thu",
  "pages.lhv_partner.fields.totalTransaction": "Tổng số giao dịch",
  "pages.lhv_partner.modal.reset.confirm": "Bạn có chắc chắn muốn reset thiết bị này?",
  "pages.lhv_partner.status.offline": "Mất kết nối",
  "pages.lhv_partner.status.online": "Trực tuyến",
  "pages.lhv_partner.table.title": "Danh sách thiết bị Loa Heo Vàng",
  "pages.login.accountLogin.errorMessage": "Tên tài khoản và mật khẩu không đúng",
  "pages.login.forgotPassword": "Quên mật khẩu",
  "pages.login.password.placeholder": "Mật khẩu",
  "pages.login.password.required": "Hãy nhập mật khẩu!",
  "pages.login.rememberMe": "Ghi nhớ đăng nhập",
  "pages.login.subTitle": "Đăng nhập",
  "pages.login.submitText": "Đăng nhập",
  "pages.login.success": "Đăng nhập thành công",
  "pages.login.title": "Quản trị hệ thống An Vui",
  "pages.login.username.placeholder": "Tên tài khoản",
  "pages.login.username.required": "Hãy nhập tên tài khoản!",
  "pages.mbqr.payments.actions.callback_trigger": "Kiểm tra giao dịch",
  "pages.mbqr.payments.actions.refund": "Yêu cầu hoàn tiền",
  "pages.mbqr.payments.actions.view_refund": "Xem giao dịch hoàn tiền",
  "pages.mbqr.payments.detailForm.title": "Thông tin chi tiết giao dịch",
  "pages.mbqr.payments.fields.billNumber": "Mã giao dịch",
  "pages.mbqr.payments.fields.billNumber.tips": "Mã giao dịch của AV",
  "pages.mbqr.payments.fields.callbackRespCode": "Kết quả callback",
  "pages.mbqr.payments.fields.callbackRespDesc": "Nội dung callback",
  "pages.mbqr.payments.fields.content": "Ghi chú",
  "pages.mbqr.payments.fields.createdAt": "Ngày tạo",
  "pages.mbqr.payments.fields.description": "Mô tả chi tiết",
  "pages.mbqr.payments.fields.feeAmount": "Tiền phí QR",
  "pages.mbqr.payments.fields.ftCode": "Mã FT",
  "pages.mbqr.payments.fields.ftCode.tips": "Mã ftCode, phục vụ đối soát và hoàn tiền sau này",
  "pages.mbqr.payments.fields.notice": "Ghi chú",
  "pages.mbqr.payments.fields.payDate": "Ngày thanh toán",
  "pages.mbqr.payments.fields.qrPercentage": "Phí % QR",
  "pages.mbqr.payments.fields.referenceLabelCode": "Mã giao dịch MB",
  "pages.mbqr.payments.fields.referenceLabelCode.tips": "Mã giao dịch gửi sang MB",
  "pages.mbqr.payments.fields.refundAmount": "Số tiền hoàn",
  "pages.mbqr.payments.fields.status": "Trạng thái",
  "pages.mbqr.payments.fields.terminalID": "Mã cổng",
  "pages.mbqr.payments.fields.terminalID.tips": "ID định danh cổng thanh toán của nhà xe trên AnVui và MB",
  "pages.mbqr.payments.fields.terminalName": "Tên cổng TT",
  "pages.mbqr.payments.fields.terminalName.tips": "Mã nhà xe, hoặc tên cổng thanh toán",
  "pages.mbqr.payments.fields.traceTransfer": "Số trace",
  "pages.mbqr.payments.fields.traceTransfer.tips": "Số trace của hệ thống bank, do hệ thống bank tự sinh",
  "pages.mbqr.payments.fields.transactionAmount": "Số tiền",
  "pages.mbqr.payments.modal.callback_trigger.title": "Bạn có chắc chắn muốn gọi lại callback?",
  "pages.mbqr.payments.modal.refund.title": "Bạn có chắc chắn muốn hoàn tiền?",
  "pages.mbqr.payments.title": "Giao dịch thanh toán MB",
  "pages.mbqr.refund.field.createdAt": "Ngày hoàn tiền",
  "pages.mbqr.refund.fields.amount": "Số tiền",
  "pages.mbqr.refund.fields.billNumber": "Mã giao dịch",
  "pages.mbqr.refund.fields.billNumber.tips": "Mã giao dịch được hoàn của AV",
  "pages.mbqr.refund.fields.ftCode": "Mã FT",
  "pages.mbqr.refund.fields.ftCode.tips": "Mã ftCode giao dịch hoàn tiền",
  "pages.mbqr.refund.fields.terminalID": "Mã cổng",
  "pages.mbqr.refund.fields.terminalID.tips": "ID định danh cổng thanh toán của nhà xe trên AnVui và MB",
  "pages.mbqr.refund.fields.traceTransfer": "Số trace",
  "pages.mbqr.refund.fields.traceTransfer.tips": "Số trace của giao dịch được hoàn",
  "pages.mbqr.refund.title": "Giao dịch hoàn tiền",
  "pages.mbqr.terminals.actions.approve": "Phê duyệt",
  "pages.mbqr.terminals.actions.deny": "Từ chối",
  "pages.mbqr.terminals.actions.register_again": "Đăng ký lại",
  "pages.mbqr.terminals.actions.update_fee": "Cập nhật phí",
  "pages.mbqr.terminals.button.batchApprove": "Phê duyệt hàng loạt",
  "pages.mbqr.terminals.button.batchDeny": "Từ chối hàng loạt",
  "pages.mbqr.terminals.detailForm.title": "Thông tin chi tiết cổng thanh toán MB QR",
  "pages.mbqr.terminals.field.createdAt": "Ngày tạo",
  "pages.mbqr.terminals.fields.bankAccountName": "Tên tài khoản",
  "pages.mbqr.terminals.fields.bankAccountNumber": "Số tài khoản",
  "pages.mbqr.terminals.fields.identityNumber": "Số CCCD/CMT",
  "pages.mbqr.terminals.fields.otpValue": "Mã OTP",
  "pages.mbqr.terminals.fields.phoneNo": "Số điện thoại",
  "pages.mbqr.terminals.fields.qrPercentage": "Phí giao dịch",
  "pages.mbqr.terminals.fields.status": "Trạng thái",
  "pages.mbqr.terminals.fields.terminalId": "Mã cổng",
  "pages.mbqr.terminals.fields.terminalId.tips": "ID định danh cổng thanh toán của nhà xe trên AnVui và MB",
  "pages.mbqr.terminals.fields.terminalName": "Tên cổng TT",
  "pages.mbqr.terminals.fields.terminalName.tips": "ID định danh của đối tác, mã nhà xe, mã khách hàng",
  "pages.mbqr.terminals.fields.vaNumber": "Số tài khoản ảo NAPAS",
  "pages.mbqr.terminals.message.wrong_otp": "OTP không chính xác",
  "pages.mbqr.terminals.modals.approve": "Bạn có chắc chắn muốn phê duyệt?",
  "pages.mbqr.terminals.modals.deny": "Bạn có chắc chắn muốn từ chối?",
  "pages.mbqr.terminals.newForm.title": "Thêm cổng thanh toán MB QR",
  "pages.mbqr.terminals.table.footerText": "| Chờ phê duyệt: {pending} | Bị từ chối: {deny}",
  "pages.mbqr.terminals.table.title": "Danh sách cổng thanh toán MB QR",
  "pages.mbqr.terminals.updateForm.title": "Cập nhật cổng thanh toán MB QR",
  "pages.menu.addForm.title": "Thêm menu theo gói",
  "pages.menu.fields.companyName": "Tên gói",
  "pages.menu.fields.id": "Id",
  "pages.menu.fields.id.tips": "Mã gói là duy nhất",
  "pages.menu.fields.name": "Tên gói",
  "pages.menu.popup.table.key": "Mục",
  "pages.menu.popup.table.name": "Tên",
  "pages.menu.table.title": "Danh sách gói",
  "pages.menu.updateForm.title": "Cập nhật menu theo gói",
  "pages.merchant.actions.update": "Cập nhật",
  "pages.merchant.createForm.title": "Tạo mới cổng thanh toán",
  "pages.merchant.fields.anvuiUser": "Người tạo",
  "pages.merchant.fields.companyId": "Nhà xe",
  "pages.merchant.fields.createdDate": "Ngày tạo",
  "pages.merchant.fields.gateway": "Cổng thanh toán",
  "pages.merchant.fields.index": "STT",
  "pages.merchant.fields.isActive": "Trạng thái",
  "pages.merchant.fields.isProduction": "Môi trường",
  "pages.merchant.fields.merchantId": "Merchant ID",
  "pages.merchant.fields.modifiedDate": "Ngày cập nhật",
  "pages.merchant.fields.transactionFee": "Phí giao dịch",
  "pages.merchant.fields.transactionPercent": "Phí %",
  "pages.merchant.form.accessCode.placeholder": "Nhập Access Code",
  "pages.merchant.form.appId.placeholder": "Nhập App ID",
  "pages.merchant.form.cbKey.placeholder": "Nhập Cb Key",
  "pages.merchant.form.gateway.label": "Cổng thanh toán:",
  "pages.merchant.form.hash.placeholder": "Nhập Hash",
  "pages.merchant.form.isProduction.label": "Môi trường Production",
  "pages.merchant.form.isProduction.tooltip": "Bật để sử dụng môi trường Production, tắt để sử dụng môi trường Test",
  "pages.merchant.form.macKey.placeholder": "Nhập Mac Key",
  "pages.merchant.form.merchantId.placeholder": "Nhập Merchant ID",
  "pages.merchant.form.platform.placeholder": "Chọn phương tiện",
  "pages.merchant.form.returnUrl.placeholder": "Nhập Return URL",
  "pages.merchant.form.storeId.placeholder": "Nhập Store ID",
  "pages.merchant.form.transactionFee.placeholder": "Nhập phí thanh toán cố định",
  "pages.merchant.form.transactionPercent.placeholder": "Nhập phí thanh toán theo %",
  "pages.merchant.table.title": "Danh sách cổng thanh toán",
  "pages.merchant.title": "Quản lý cổng thanh toán",
  "pages.merchant.updateForm.title": "Cập nhật cổng thanh toán {gateway}",
  "pages.napasqr.payments.detailForm.title": "Thông tin chi tiết giao dịch",
  "pages.napasqr.payments.fields.billNumber": "Mã giao dịch",
  "pages.napasqr.payments.fields.billNumber.tips": "Mã giao dịch của AV",
  "pages.napasqr.payments.fields.callbackRespCode": "Kết quả callback",
  "pages.napasqr.payments.fields.callbackRespDesc": "Nội dung callback",
  "pages.napasqr.payments.fields.createdAt": "Ngày tạo",
  "pages.napasqr.payments.fields.description": "Mô tả chi tiết",
  "pages.napasqr.payments.fields.feeAmount": "Tiền phí QR",
  "pages.napasqr.payments.fields.ftCode": "Mã FT",
  "pages.napasqr.payments.fields.ftCode.tips": "Mã ftCode, phục vụ đối soát và hoàn tiền sau này",
  "pages.napasqr.payments.fields.notice": "Ghi chú",
  "pages.napasqr.payments.fields.payDate": "Ngày thanh toán",
  "pages.napasqr.payments.fields.qrPercentage": "Phí % QR",
  "pages.napasqr.payments.fields.referenceLabelCode": "Mã giao dịch Napas",
  "pages.napasqr.payments.fields.referenceLabelCode.tips": "Mã giao dịch gửi sang Napas",
  "pages.napasqr.payments.fields.refundAmount": "Số tiền hoàn",
  "pages.napasqr.payments.fields.status": "Trạng thái",
  "pages.napasqr.payments.fields.terminalID": "Mã cổng",
  "pages.napasqr.payments.fields.terminalID.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và Napas",
  "pages.napasqr.payments.fields.terminalName": "Tên cổng TT",
  "pages.napasqr.payments.fields.terminalName.tips": "Mã nhà xe, hoặc tên cổng thanh toán",
  "pages.napasqr.payments.fields.traceTransfer": "Số trace",
  "pages.napasqr.payments.fields.traceTransfer.tips": "Số trace của hệ thống bank, do hệ thống bank tự sinh",
  "pages.napasqr.payments.fields.transactionAmount": "Số tiền",
  "pages.napasqr.payments.title": "Giao dịch thanh toán Napas",
  "pages.napasqr.terminals.actions.approve": "Phê duyệt",
  "pages.napasqr.terminals.actions.deny": "Từ chối",
  "pages.napasqr.terminals.actions.update_fee": "Cập nhật phí",
  "pages.napasqr.terminals.approveForm.title": "Phê duyệt cổng thanh toán Napas QR",
  "pages.napasqr.terminals.button.batchDeny": "Từ chối hàng loạt",
  "pages.napasqr.terminals.field.createdAt": "Ngày tạo",
  "pages.napasqr.terminals.fields.bankAccountName": "Tên tài khoản",
  "pages.napasqr.terminals.fields.bankAccountNumber": "Số tài khoản",
  "pages.napasqr.terminals.fields.identityNumber": "Số CCCD/CMT",
  "pages.napasqr.terminals.fields.phoneNo": "Số điện thoại",
  "pages.napasqr.terminals.fields.qrPercentage": "Phí giao dịch",
  "pages.napasqr.terminals.fields.status": "Trạng thái",
  "pages.napasqr.terminals.fields.terminalId": "Mã cổng",
  "pages.napasqr.terminals.fields.terminalId.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và Napas",
  "pages.napasqr.terminals.fields.terminalName": "Tên cổng TT",
  "pages.napasqr.terminals.fields.vaNumber": "Số tài khoản ảo NAPAS",
  "pages.napasqr.terminals.modals.deny": "Bạn có chắc chắn muốn từ chối?",
  "pages.napasqr.terminals.table.footerText": "| Chờ phê duyệt: {pending} | Bị từ chối: {deny}",
  "pages.napasqr.terminals.table.title": "Danh sách cổng thanh toán Napas QR",
  "pages.napasqr.terminals.updateForm.title": "Cập nhật cổng thanh toán Napas QR",
  "pages.payment.package.addForm.title": "Thêm gói khuyến mãi",
  "pages.payment.package.amount": "Số tiền nạp",
  "pages.payment.package.companyid": "Công ty",
  "pages.payment.package.date": "Ngày khuyến mãi",
  "pages.payment.package.detail.title": "Thông tin chi tiết gói nạp tiền",
  "pages.payment.package.editForm.title": "Sửa gói khuyến mãi",
  "pages.payment.package.fields.active": "Trạng thái",
  "pages.payment.package.fields.amount": "Số tiền",
  "pages.payment.package.fields.id": "Mã gói nạp tiền",
  "pages.payment.package.fields.id.tips": "Mã gói nạp tiền là duy nhất",
  "pages.payment.package.fields.name": "Tên gói",
  "pages.payment.package.fields.promotion": "Khuyến mãi",
  "pages.payment.package.name": "Tên gói",
  "pages.payment.package.promotion": "Số tiền khuyến mãi",
  "pages.payment.package.table.title": "Danh sách gói nạp tiền",
  "pages.permission.addForm.title": "Thêm phân quyền",
  "pages.permission.detailForm.title": "Thông tin phân quyền",
  "pages.permission.fields.id": "Id",
  "pages.permission.fields.name": "Tên quyền",
  "pages.permission.fields.statements": "Danh sách quyền",
  "pages.permission.table.title": "Danh sách quyền",
  "pages.permission.tips.id": "Id là duy nhất",
  "pages.permission.updateForm.title": "Cập nhật phân quyền",
  "pages.report.company-charge-wallet.title": "Báo cáo tình hình nạp tiền nhà xe",
  "pages.report.company-payment-transaction.addForm.resetText": "Đóng",
  "pages.report.company-payment-transaction.addForm.submitText": "Tạo giao dịch",
  "pages.report.company-payment-transaction.addForm.title": "Tạo giao dịch",
  "pages.report.company-payment-transaction.fields.companyId": "Nhà xe",
  "pages.report.company-payment-transaction.fields.paymentType": "Loại giao dịch",
  "pages.report.company-payment-transaction.fields.paymentType.chargeWallet": "Thu tiền nạp phí sử dụng",
  "pages.report.company-payment-transaction.fields.paymentType.initializationFee": "Thu phí khởi tạo",
  "pages.report.company-payment-transaction.fields.transactionAmount": "Số tiền nhà xe nộp",
  "pages.report.company-payment-transaction.fields.transactionAmount.placeholder": "Nhập số tiền",
  "pages.report.company-payment-transaction.title": "Danh sách giao dịch phí nhà xe",
  "pages.report.company-revenue.title": "Báo cáo doanh thu nhà xe",
  "pages.system_banner.detailForm.title": "Thông tin banner",
  "pages.system_banner.fields.createdAt": "Ngày tạo",
  "pages.system_banner.fields.imageUrl": "Hình ảnh",
  "pages.system_banner.fields.imageUrl.placeholder": "Vui lòng tải lên hình ảnh",
  "pages.system_banner.fields.isActive": "Trạng thái",
  "pages.system_banner.fields.link": "Link liên kết",
  "pages.system_banner.fields.link.placeholder": "Vui lòng nhập link liên kết",
  "pages.system_banner.fields.location": "Vị trí hiển thị",
  "pages.system_banner.fields.location.placeholder": "Vui lòng chọn vị trí hiển thị",
  "pages.system_banner.fields.type": "Loại banner",
  "pages.system_banner.fields.type.placeholder": "Vui lòng chọn loại banner",
  "pages.system_banner.fields.updatedAt": "Ngày cập nhật",
  "pages.system_banner.newForm.title": "Thêm mới banner",
  "pages.system_banner.table.title": "Danh sách banner",
  "pages.transit.group.create.close": "Đóng",
  "pages.transit.group.create.error": "Tạo nhóm thất bại",
  "pages.transit.group.create.name.label": "Tên nhóm trung chuyển",
  "pages.transit.group.create.name.placeholder": "Hãy nhập tên nhóm trung chuyển",
  "pages.transit.group.create.name.required": "Vui lòng nhập tên nhóm trung chuyển",
  "pages.transit.group.create.submit": "Tạo nhóm",
  "pages.transit.group.create.success": "Tạo nhóm thành công",
  "pages.transit.group.create.title": "Tạo nhóm danh sách trung chuyển mới",
  "pages.transit.kanban.empty": "Không có dữ liệu",
  "pages.transit.order.confirm.boardingTime": "Giờ xe chạy",
  "pages.transit.order.confirm.cancel": "Hủy",
  "pages.transit.order.confirm.confirm": "Xác nhận tạo đơn",
  "pages.transit.order.confirm.instruction": "Vui lòng kiểm tra thông tin các khách hàng trước khi tạo đơn:",
  "pages.transit.order.confirm.orderTime": "Giờ phải đón dự tính",
  "pages.transit.order.confirm.subtitle": "Đã chọn {count} khách hàng",
  "pages.transit.order.confirm.table.boardingTime": "Giờ xe chạy",
  "pages.transit.order.confirm.table.customer.fullName": "Tên khách hàng",
  "pages.transit.order.confirm.table.customer.phoneNumber": "Số điện thoại",
  "pages.transit.order.confirm.table.dropoff.address": "Địa chỉ trả",
  "pages.transit.order.confirm.table.pickup.address": "Địa chỉ đón",
  "pages.transit.order.confirm.title": "Xác nhận tạo đơn trung chuyển",
  "pages.transit.order.confirm.totalDistance": "Tổng quãng đường:",
  "pages.transit.order.confirm.totalDuration": "Thời gian di chuyển:",
  "pages.transit.service.selection.cancel": "Hủy",
  "pages.transit.service.selection.confirm": "Xác nhận",
  "pages.transit.service.selection.empty": "Không có dịch vụ khả dụng",
  "pages.transit.service.selection.fee.amount": "Số tiền",
  "pages.transit.service.selection.fee.detail": "Chi tiết các phí khác",
  "pages.transit.service.selection.fee.title": "Phí dịch vụ",
  "pages.transit.service.selection.fee.total": "Tổng phí (total_fee)",
  "pages.transit.service.selection.fee.type": "Loại phí",
  "pages.transit.service.selection.fetch.error": "Có lỗi khi tải danh sách dịch vụ",
  "pages.transit.service.selection.max.extra.stop": "Số điểm dừng tối đa",
  "pages.transit.service.selection.select.label": "Chọn dịch vụ",
  "pages.transit.service.selection.select.placeholder": "Vui lòng chọn dịch vụ",
  "pages.transit.service.selection.service.id": "ID Dịch vụ",
  "pages.transit.service.selection.service.info": "Thông tin dịch vụ",
  "pages.transit.service.selection.service.type": "Loại dịch vụ",
  "pages.transit.service.selection.subtitle": "Đã chọn {count} khách hàng",
  "pages.transit.service.selection.title": "Thông tin Dịch vụ trung chuyển",
  "pages.transit.service.selection.travel.mode": "Phương tiện",
  "pages.transit.service.selection.warning": "Không có dịch vụ khả dụng",
  "pages.transit.with.partner.actions.add.new": "Thêm mới nhóm",
  "pages.transit.with.partner.actions.call": "Gọi trung chuyển ngay",
  "pages.transit.with.partner.actions.createOrder": "Tạo đơn trung chuyển",
  "pages.transit.with.partner.actions.sort": "Chia nhóm",
  "pages.transit.with.partner.fields.address": "Địa điểm trung chuyển đón",
  "pages.transit.with.partner.fields.address.tips": "Xe trung chuyển cần đón khách tại địa điểm này",
  "pages.transit.with.partner.fields.estPickupTime": "Giờ phải đón dự tính",
  "pages.transit.with.partner.fields.extraInfo": "Thông tin thêm",
  "pages.transit.with.partner.fields.fullName": "Thông tin khách",
  "pages.transit.with.partner.fields.isArranged": "Trạng thái",
  "pages.transit.with.partner.fields.phoneNumber": "Số điện thoại",
  "pages.transit.with.partner.fields.pickupTime": "Giờ xe chạy",
  "pages.transit.with.partner.fields.pickupTime.tips": "Chú thích: 🔴 Còn 30 phút là tới thời gian trung chuyển đón 🟠 Còn 2 tiếng là tới thời gian trung chuyển đón",
  "pages.transit.with.partner.fields.point.address": "Địa điểm trung chuyển trả",
  "pages.transit.with.partner.fields.point.estDistance": "Khoảng cách( Km)",
  "pages.transit.with.partner.fields.pointDirection": "Loại hình TC",
  "pages.transit.with.partner.fields.sex": "Giới tính",
  "pages.transit.with.partner.fields.ticketCode": "Mã vé",
  "pages.transit.with.partner.kanban.create.group": "Tạo nhóm",
  "pages.transit.with.partner.kanban.title": "Danh sách đợi trung chuyển",
  "pages.transit.with.partner.list.search.dropoff.point": "Địa điểm trả",
  "pages.transit.with.partner.list.search.dropoff.province.placeholder": "Chọn tỉnh/thành phố",
  "pages.transit.with.partner.list.search.dropoff.ward.placeholder": "Chọn phường",
  "pages.transit.with.partner.list.search.pickup.point": "Địa điểm đón",
  "pages.transit.with.partner.list.search.pickup.province.placeholder": "Chọn tỉnh/thành phố",
  "pages.transit.with.partner.list.search.pickup.ward.placeholder": "Chọn phường",
  "pages.transit.with.partner.list.search.pickupTime": "Thời gian đón",
  "pages.transit.with.partner.list.search.status": "Trạng thái",
  "pages.transit.with.partner.list.search.status.all": "Tất cả",
  "pages.transit.with.partner.list.search.status.arranged": "Đang xử lý",
  "pages.transit.with.partner.list.search.status.unarranged": "Chưa xử lý",
  "pages.transit.with.partner.list.search.tag": "Chọn nhãn",
  "pages.transit.with.partner.list.search.tag.placeholder": "Chọn nhãn",
  "pages.transit.with.partner.search.placeholder": "Tìm kiếm theo tên, số điện thoại",
  "pages.transitConfig.servicePackageList.actions.createButton": "Thêm gói mới",
  "pages.transitConfig.servicePackageList.actions.deleteConfirmCancel": "Hủy",
  "pages.transitConfig.servicePackageList.actions.deleteConfirmContent": "Bạn có chắc chắn muốn xóa gói này?",
  "pages.transitConfig.servicePackageList.actions.deleteConfirmOk": "Xóa",
  "pages.transitConfig.servicePackageList.actions.deleteConfirmTitle": "Xác nhận xóa gói",
  "pages.transitConfig.servicePackageList.actions.disableConfirmContent": "Bạn có chắc chắn muốn vô hiệu hóa gói này?",
  "pages.transitConfig.servicePackageList.actions.disableConfirmTitle": "Xác nhận vô hiệu hóa",
  "pages.transitConfig.servicePackageList.modal.cancelButton": "Đóng",
  "pages.transitConfig.servicePackageList.modal.fields.addSurchargeTier": "Thêm mốc giá",
  "pages.transitConfig.servicePackageList.modal.fields.baseDistance": "Quãng đường mở cửa",
  "pages.transitConfig.servicePackageList.modal.fields.baseDistancePlaceholder": "Ví dụ: 360",
  "pages.transitConfig.servicePackageList.modal.fields.baseDistanceRequired": "Vui lòng nhập quãng đường mở cửa",
  "pages.transitConfig.servicePackageList.modal.fields.basePrice": "Giá mở cửa",
  "pages.transitConfig.servicePackageList.modal.fields.basePricePlaceholder": "Ví dụ: 35.000",
  "pages.transitConfig.servicePackageList.modal.fields.basePriceRequired": "Vui lòng nhập giá mở cửa",
  "pages.transitConfig.servicePackageList.modal.fields.code": "Mã gói",
  "pages.transitConfig.servicePackageList.modal.fields.codePlaceholder": "Ví dụ: VIP1",
  "pages.transitConfig.servicePackageList.modal.fields.codeRequired": "Vui lòng nhập mã gói",
  "pages.transitConfig.servicePackageList.modal.fields.discountPercentage": "% giảm giá lũy tiến",
  "pages.transitConfig.servicePackageList.modal.fields.discountPercentageRequired": "Vui lòng nhập % giảm giá lũy tiến",
  "pages.transitConfig.servicePackageList.modal.fields.discountThreshold": "Mốc dừng giảm giá lũy tiến",
  "pages.transitConfig.servicePackageList.modal.fields.discountThresholdRequired": "Vui lòng nhập mốc dừng giảm giá lũy tiến",
  "pages.transitConfig.servicePackageList.modal.fields.excludedSurchargeTypes": "Phụ thu không áp dụng",
  "pages.transitConfig.servicePackageList.modal.fields.fractionalKmRule": "Quy tắc km lẻ",
  "pages.transitConfig.servicePackageList.modal.fields.fractionalKmRulePlaceholder": "Chọn quy tắc km lẻ",
  "pages.transitConfig.servicePackageList.modal.fields.fromKmExclusive": "Từ KM (không bao gồm)",
  "pages.transitConfig.servicePackageList.modal.fields.fromKmExclusiveRequired": "Nhập số KM",
  "pages.transitConfig.servicePackageList.modal.fields.groupConfig": "Cấu hình vé đoàn",
  "pages.transitConfig.servicePackageList.modal.fields.isActive": "Trạng thái",
  "pages.transitConfig.servicePackageList.modal.fields.isDedicatedVehicle": "Xe phục vụ riêng",
  "pages.transitConfig.servicePackageList.modal.fields.isSelfRegistrationEnabled": "Tự đăng ký",
  "pages.transitConfig.servicePackageList.modal.fields.name": "Tên gói",
  "pages.transitConfig.servicePackageList.modal.fields.namePlaceholder": "Ví dụ: Gói VIP",
  "pages.transitConfig.servicePackageList.modal.fields.nameRequired": "Vui lòng nhập tên gói",
  "pages.transitConfig.servicePackageList.modal.fields.perKmFee": "Giá / KM (VNĐ)",
  "pages.transitConfig.servicePackageList.modal.fields.perKmFeeRequired": "Nhập giá / KM",
  "pages.transitConfig.servicePackageList.modal.fields.surchargeAfter": "Bảng giá cộng thêm theo quãng đường",
  "pages.transitConfig.servicePackageList.modal.fields.type": "Loại gói",
  "pages.transitConfig.servicePackageList.modal.fields.typePlaceholder": "Chọn loại gói",
  "pages.transitConfig.servicePackageList.modal.fields.typeRequired": "Vui lòng chọn loại gói",
  "pages.transitConfig.servicePackageList.modal.fields.vatPercent": "Phí VAT",
  "pages.transitConfig.servicePackageList.modal.fields.vatPercentPlaceholder": "Ví dụ: 8",
  "pages.transitConfig.servicePackageList.modal.fields.vatPercentRequired": "Vui lòng nhập phí VAT",
  "pages.transitConfig.servicePackageList.modal.submitButton": "Cập nhật",
  "pages.transitConfig.servicePackageList.type.basic": "Cơ bản",
  "pages.transitConfig.servicePackageList.type.fullVehicle4Seat": "Bao xe 4 chỗ",
  "pages.transitConfig.servicePackageList.type.fullVehicle7Seat": "Bao xe 7 chỗ",
  "pages.transitDispatchDisplayConfig.delete.confirm": "Bạn có chắc muốn xóa cấu hình này?",
  "pages.transitDispatchDisplayConfig.fields.description": "Mô tả",
  "pages.transitDispatchDisplayConfig.fields.displaySubtitle": "Phụ đề hiển thị",
  "pages.transitDispatchDisplayConfig.fields.displaySubtitle.placeholder": "VD: Cập nhật theo thời gian thực",
  "pages.transitDispatchDisplayConfig.fields.displaySubtitle.tooltip": "Dòng mô tả phụ hiển thị dưới tiêu đề",
  "pages.transitDispatchDisplayConfig.fields.displayTitle": "Tiêu đề hiển thị",
  "pages.transitDispatchDisplayConfig.fields.displayTitle.placeholder": "VD: Thông tin điều phối trung chuyển",
  "pages.transitDispatchDisplayConfig.fields.displayTitle.tooltip": "Tiêu đề chính hiển thị trên màn hình điều phối công khai",
  "pages.transitDispatchDisplayConfig.fields.index": "STT",
  "pages.transitDispatchDisplayConfig.fields.logos": "Logo hiển thị",
  "pages.transitDispatchDisplayConfig.fields.logos.hint": "Tối đa 3 logo, mỗi file ≤ 512KB (JPG, PNG, WEBP)",
  "pages.transitDispatchDisplayConfig.fields.logos.invalidType": "Chỉ chấp nhận file JPG, PNG hoặc WEBP",
  "pages.transitDispatchDisplayConfig.fields.logos.maxSize": "Kích thước logo tối đa {maxSize}KB",
  "pages.transitDispatchDisplayConfig.fields.logos.upload": "Tải logo",
  "pages.transitDispatchDisplayConfig.fields.name": "Tên cấu hình",
  "pages.transitDispatchDisplayConfig.fields.name.placeholder": "Nhập tên cấu hình...",
  "pages.transitDispatchDisplayConfig.fields.timeWindowMinutes": "Thời gian hiển thị danh sách hành khách (phút)",
  "pages.transitDispatchDisplayConfig.fields.timeWindowMinutes.min": "Giá trị phải lớn hơn hoặc bằng 1",
  "pages.transitDispatchDisplayConfig.fields.timeWindowMinutes.placeholder": "Nhập số phút (mặc định 30)",
  "pages.transitDispatchDisplayConfig.fields.timeWindowMinutes.required": "Vui lòng nhập thời gian hiển thị",
  "pages.transitDispatchDisplayConfig.fields.timeWindowMinutes.tooltip": "Số phút hiển thị danh sách hành khách gần nhất",
  "pages.transitDispatchDisplayConfig.fields.transferType": "Loại TC",
  "pages.transitDispatchDisplayConfig.fields.url": "Link URL",
  "pages.transitDispatchDisplayConfig.table.title": "Danh sách cấu hình hiển thị",
  "pages.transit_anvui_stop_point.detailForm.title": "Thông tin điểm dừng",
  "pages.transit_anvui_stop_point.fields.addressText": "Địa chỉ",
  "pages.transit_anvui_stop_point.fields.addressText.placeholder": "Nhập địa chỉ chi tiết",
  "pages.transit_anvui_stop_point.fields.commune": "Phường/Xã",
  "pages.transit_anvui_stop_point.fields.commune.placeholder": "Nhập phường/xã",
  "pages.transit_anvui_stop_point.fields.coordinates": "Tọa độ",
  "pages.transit_anvui_stop_point.fields.createdAt": "Ngày tạo",
  "pages.transit_anvui_stop_point.fields.displayName": "Tên điểm dừng",
  "pages.transit_anvui_stop_point.fields.displayName.placeholder": "Nhập tên điểm dừng",
  "pages.transit_anvui_stop_point.fields.displayName.tips": "Tên hiển thị của điểm dừng",
  "pages.transit_anvui_stop_point.fields.latitude": "Vĩ độ",
  "pages.transit_anvui_stop_point.fields.latitude.placeholder": "Nhập vĩ độ (VD: 10.762622)",
  "pages.transit_anvui_stop_point.fields.longitude": "Kinh độ",
  "pages.transit_anvui_stop_point.fields.longitude.placeholder": "Nhập kinh độ (VD: 106.660172)",
  "pages.transit_anvui_stop_point.fields.province": "Tỉnh/Thành phố",
  "pages.transit_anvui_stop_point.fields.province.placeholder": "Nhập tỉnh/thành phố",
  "pages.transit_anvui_stop_point.fields.stopType": "Loại điểm dừng",
  "pages.transit_anvui_stop_point.fields.stopType.placeholder": "Chọn loại điểm dừng",
  "pages.transit_anvui_stop_point.newForm.cancel": "Hủy",
  "pages.transit_anvui_stop_point.newForm.confirm": "Tạo mới",
  "pages.transit_anvui_stop_point.newForm.title": "Tạo mới điểm dừng",
  "pages.transit_anvui_stop_point.placeDetails.error": "Không thể lấy thông tin chi tiết địa điểm",
  "pages.transit_anvui_stop_point.table.title": "Danh sách điểm dừng Transit AnVui",
  "pages.transit_anvui_stop_point.updateForm.cancel": "Hủy",
  "pages.transit_anvui_stop_point.updateForm.confirm": "Cập nhật",
  "pages.transit_anvui_stop_point.updateForm.subtitle": "Chỉnh sửa thông tin điểm dừng: {name}",
  "pages.transit_anvui_stop_point.updateForm.title": "Cập nhật điểm dừng",
  "pages.transit_config.panel.package_list": "Danh sách gói dịch vụ",
  "pages.transit_config.panel.registration_history": "Lịch sử đăng ký dịch vụ",
  "pages.transit_config.panel.surcharge": "Cấu hình thời gian và phụ phí",
  "pages.transit_config.service_package.actions.delete": "Xóa gói",
  "pages.transit_config.service_package.actions.disable": "Vô hiệu hóa gói",
  "pages.transit_config.service_package.actions.edit": "Chỉnh sửa thông tin gói",
  "pages.transit_config.service_package.fields.active": "Trạng thái",
  "pages.transit_config.service_package.fields.basePrice": "Giá mở cửa",
  "pages.transit_config.service_package.fields.code": "Mã gói",
  "pages.transit_config.service_package.fields.index": "STT",
  "pages.transit_config.service_package.fields.isSelfRegistrationEnabled": "Tự đăng ký",
  "pages.transit_config.service_package.fields.name": "Tên gói",
  "pages.transit_config.service_package.fields.openDistanceKm": "Quãng đường mở cửa",
  "pages.transit_config.service_package.fields.surchargePerKm": "Giá phụ thu",
  "pages.transit_config.service_package.fields.type": "Loại gói",
  "pages.transit_config.service_package.fields.vatPercent": "Phí VAT",
  "pages.transit_config.service_package.status.active": "Hoạt động",
  "pages.transit_config.service_package.status.disabled": "Tắt",
  "pages.transit_config.service_package.status.enabled": "Bật",
  "pages.transit_config.service_package.status.inactive": "Không hoạt động",
  "pages.transit_config.service_registration_company_log.action.delete": "Hủy",
  "pages.transit_config.service_registration_company_log.action.insert": "Đăng ký mới",
  "pages.transit_config.service_registration_company_log.action.update": "Nâng cấp gói",
  "pages.transit_config.service_registration_company_log.fields.action": "Hành động",
  "pages.transit_config.service_registration_history.actions.add_package": "Đăng ký thêm gói",
  "pages.transit_config.service_registration_history.actions.delete_confirm_content": "Bạn có chắc chắn muốn hủy gói dịch vụ này?",
  "pages.transit_config.service_registration_history.actions.delete_confirm_title": "Xác nhận hủy gói",
  "pages.transit_config.service_registration_history.actions.delete_package": "Hủy gói",
  "pages.transit_config.service_registration_history.actions.switch_package": "Chuyển gói",
  "pages.transit_config.service_registration_history.add_package.cancel": "Hủy",
  "pages.transit_config.service_registration_history.add_package.confirm": "Đăng ký",
  "pages.transit_config.service_registration_history.add_package.loading": "Đang đăng ký...",
  "pages.transit_config.service_registration_history.add_package.package_info": "Thông tin gói",
  "pages.transit_config.service_registration_history.add_package.select_company_placeholder": "Chọn nhà xe",
  "pages.transit_config.service_registration_history.add_package.select_package_placeholder": "Chọn gói dịch vụ",
  "pages.transit_config.service_registration_history.add_package.success": "Đăng ký gói thành công",
  "pages.transit_config.service_registration_history.add_package.title": "Đăng ký thêm gói cho nhà xe",
  "pages.transit_config.service_registration_history.button.update": "Cập nhật",
  "pages.transit_config.service_registration_history.fields.distanceAtPurchase": "Quãng đường mở cửa",
  "pages.transit_config.service_registration_history.fields.effectiveDate": "Ngày bắt đầu hiệu lực",
  "pages.transit_config.service_registration_history.fields.index": "STT",
  "pages.transit_config.service_registration_history.fields.packageCode": "Mã gói",
  "pages.transit_config.service_registration_history.fields.priceAtPurchase": "Giá mở cửa",
  "pages.transit_config.service_registration_history.fields.pricingInfo": "Thông tin giá",
  "pages.transit_config.service_registration_history.fields.transitCompanyId": "ID nhà xe",
  "pages.transit_config.service_registration_history.fields.transitCompanyName": "Tên nhà xe",
  "pages.transit_config.service_registration_history.modal.after_update": "Sau khi cập nhật:",
  "pages.transit_config.service_registration_history.modal.base_distance": "Quãng đường mở cửa:",
  "pages.transit_config.service_registration_history.modal.base_price": "Giá mở cửa:",
  "pages.transit_config.service_registration_history.modal.before_update": "Trước khi cập nhật:",
  "pages.transit_config.service_registration_history.modal.cancel": "Hủy",
  "pages.transit_config.service_registration_history.modal.confirm": "Cập nhật",
  "pages.transit_config.service_registration_history.modal.description": "Sau khi cập nhật, hệ thống sẽ áp dụng cách thu phí mới cho nhà xe. Bạn có muốn tiếp tục?",
  "pages.transit_config.service_registration_history.modal.extra_price": "Giá phụ thu:",
  "pages.transit_config.service_registration_history.modal.title": "Xác nhận cập nhật gói trung chuyển?",
  "pages.transit_config.service_registration_history.switch_package.cancel": "Hủy",
  "pages.transit_config.service_registration_history.switch_package.confirm": "Xác nhận",
  "pages.transit_config.service_registration_history.switch_package.current_package": "Gói hiện tại",
  "pages.transit_config.service_registration_history.switch_package.new_package": "Gói sẽ chuyển",
  "pages.transit_config.service_registration_history.switch_package.select_placeholder": "Chọn gói mới",
  "pages.transit_config.service_registration_history.switch_package.title": "Chuyển gói dịch vụ",
  "pages.transit_config.service_registration_history.tabs.list": "Danh sách nhà xe sử dụng dịch vụ",
  "pages.transit_config.service_registration_history.tabs.orders": "Lịch sử đơn hàng",
  "pages.transit_config.service_registration_history.title": "Lịch sử đăng ký dịch vụ",
  "pages.transit_config.service_registration_history.update.failed": "Cập nhật gói thất bại",
  "pages.transit_config.service_registration_history.update.success": "Cập nhật gói thành công",
  "pages.transit_config.title": "Cấu hình phí trung chuyển",
  "pages.transit_dispatch_display_config.title": "Cấu hình hiển thị thông tin điều phối",
  "pages.transit_report.company_revenue.conversionRate": "Tỉ lệ chuyển đổi",
  "pages.transit_report.company_revenue.conversionRate.tooltip": "Tỉ lệ chuyển đổi = (Tổng khách An Vui / Tổng khách tự TC)",
  "pages.transit_report.company_revenue.homeToStationPassengerCount": "Vé TC Đón bởi AnVui",
  "pages.transit_report.company_revenue.homeToStationPassengerCount.tooltip": "Số lượng hành khách trung chuyển chiều đón do An Vui vận hành",
  "pages.transit_report.company_revenue.partnerCost": "Phí trả đối tác",
  "pages.transit_report.company_revenue.partnerCost.tooltip": "Chi phí phải trả cho đối tác (XanhSM, ...)",
  "pages.transit_report.company_revenue.selfOperatedTicketDownCount": "Vé TC Trả nhà xe",
  "pages.transit_report.company_revenue.selfOperatedTicketDownCount.tooltip": "Số lượng vé trung chuyển chiều trả do nhà xe tự vận hành",
  "pages.transit_report.company_revenue.selfOperatedTicketUpCount": "Vé TC Đón nhà xe",
  "pages.transit_report.company_revenue.selfOperatedTicketUpCount.tooltip": "Số lượng vé trung chuyển chiều đón do nhà xe tự vận hành",
  "pages.transit_report.company_revenue.stationToHomePassengerCount": "Vé TC Trả bởi AnVui",
  "pages.transit_report.company_revenue.stationToHomePassengerCount.tooltip": "Số lượng hành khách trung chuyển chiều trả do An Vui vận hành",
  "pages.transit_report.company_revenue.title": "Báo cáo Doanh thu theo nhà xe",
  "pages.transit_report.company_revenue.totalRevenue": "Tổng doanh thu",
  "pages.transit_report.company_revenue.totalRevenue.tooltip": "Tổng doanh thu cước trung chuyển",
  "pages.transit_report.direction.dropoff": "TC-Trả",
  "pages.transit_report.direction.pickup": "TC-Đón",
  "pages.transit_report.fields.additionalFee": "Phí phụ thu",
  "pages.transit_report.fields.basicFee": "Phí cơ bản",
  "pages.transit_report.fields.createdBy": "Người tạo đơn",
  "pages.transit_report.fields.distanceKm": "Khoảng cách KM",
  "pages.transit_report.fields.dropoffAddress": "Địa chỉ trả",
  "pages.transit_report.fields.feeDetail": "Chi tiết phí",
  "pages.transit_report.fields.fullName": "Hành khách",
  "pages.transit_report.fields.lastTransactionDate": "Ngày giao dịch cuối",
  "pages.transit_report.fields.madonxanh": "Mã đơn Xanh",
  "pages.transit_report.fields.ngayDi": "Ngày đi",
  "pages.transit_report.fields.phoneNumber": "Số điện thoại",
  "pages.transit_report.fields.pickupAddress": "Địa chỉ đón",
  "pages.transit_report.fields.pickupDropoffInfo": "Thông tin đón trả",
  "pages.transit_report.fields.pointDirection": "Loại Trung Chuyển",
  "pages.transit_report.fields.profit": "Lợi nhuận",
  "pages.transit_report.fields.profit.tooltip": "Lợi nhuận = Tổng doanh thu - Phí trả đối tác",
  "pages.transit_report.fields.providerFee": "Phí trả nhà cung cấp",
  "pages.transit_report.fields.status": "Trạng thái",
  "pages.transit_report.fields.ticketCode": "Mã vé",
  "pages.transit_report.fields.totalAnVuiFee": "Tổng phí An Vui",
  "pages.transit_report.fields.vatFee": "Thuế VAT",
  "pages.transit_report.staff_revenue.fields.countTicket": "Số vé",
  "pages.transit_report.staff_revenue.fields.createdByName": "Tên tài khoản",
  "pages.transit_report.staff_revenue.fields.feeanvui": "Doanh thu Nhà xe",
  "pages.transit_report.staff_revenue.fields.userName": "Tên nhân viên",
  "pages.transit_report.staff_revenue.title": "Báo cáo doanh thu theo nhân viên",
  "pages.transit_report.station.company_revenue.allocatedMiscCostPerTicket": "Đơn giá phí 1 vé trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.company_revenue.partnerCost": "Phí trả đối tác vận chuyển",
  "pages.transit_report.station.company_revenue.partnerCost.tooltip": "Chi phí phải trả cho đối tác (XanhSM, ...)",
  "pages.transit_report.station.company_revenue.partnerCostBeforeVat": "Phí trả đối tác vận chuyển trước thuế",
  "pages.transit_report.station.company_revenue.partnerCostBeforeVat.tooltip": "Phí trả đối tác vận chuyển trước thuế = Phí trả đối tác vận chuyển / 1.08",
  "pages.transit_report.station.company_revenue.profit.tooltip": "Lợi nhuận = Tổng doanh thu trước thuế - Phí trả đối tác vận chuyển trước thuế - Phí trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.company_revenue.thirdPartyCostBeforeVat": "Phí trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.company_revenue.thirdPartyCostBeforeVat.tooltip": "Phí trả cho bên thứ 3 trước thuế = (Vé TC Đón + Vé TC Trả) x Đơn giá phí 1 vé trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.company_revenue.totalRevenueBeforeVat": "Tổng doanh thu trước thuế",
  "pages.transit_report.station.company_revenue.totalRevenueBeforeVat.tooltip": "Tổng doanh thu trước thuế = Tổng doanh thu / 1.08",
  "pages.transit_report.station.company_revenue.vatDeductible": "Thuế GTGT khấu trừ",
  "pages.transit_report.station.company_revenue.vatDeductible.tooltip": "Thuế GTGT khấu trừ = Phí trả đối tác vận chuyển trước thuế x 8%",
  "pages.transit_report.station.company_revenue.vatDifference": "Chênh lệch thuế",
  "pages.transit_report.station.company_revenue.vatDifference.tooltip": "Chênh lệch thuế = Thuế GTGT phải nộp - Thuế GTGT khấu trừ",
  "pages.transit_report.station.company_revenue.vatPayable": "Thuế GTGT phải nộp",
  "pages.transit_report.station.company_revenue.vatPayable.tooltip": "Thuế GTGT phải nộp = Tổng doanh thu trước thuế x 8%",
  "pages.transit_report.station.fields.allocatedMiscCostPerTicket": "Đơn giá phí 1 vé trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.fields.partnerFeeAfterVat": "Phí trả đối tác vận chuyển sau thuế",
  "pages.transit_report.station.fields.partnerFeeBeforeVat": "Phí trả đối tác vận chuyển trước thuế",
  "pages.transit_report.station.fields.profit.tooltip": "Lợi nhuận = Doanh thu trước thuế - Phí trả đối tác vận chuyển trước thuế - Đơn giá phí 1 vé trả cho bên thứ 3 trước thuế",
  "pages.transit_report.station.fields.partnerFeeVat": "Thuế VAT",
  "pages.transit_report.station.fields.revenueAfterVat": "Doanh thu sau thuế",
  "pages.transit_report.station.fields.revenueBeforeVat": "Doanh thu trước thuế",
  "pages.transit_report.station.fields.mismatchNote": "Ghi chú",
  "pages.transit_report.station.fields.mismatchNote.tooltip": "Vé có trạng thái lệch với báo cáo vé tuyến (AV44): vé đã huỷ nhưng đơn trung chuyển đã có tài xế nhận hoặc đã hoàn thành; vé tuyến Đang giữ chỗ / Giữ chỗ ưu tiên (chưa thanh toán); hoặc trung chuyển trên vé vẫn đang chờ xe",
  "pages.transit_report.station.company_revenue.mismatchTicketCount": "Vé cần đối soát",
  "pages.transit_report.station.company_revenue.mismatchTicketCount.tooltip": "Số vé có trạng thái lệch với báo cáo vé tuyến (AV44), tương ứng cột Ghi chú của Báo cáo Trung chuyển bến xe theo vé (đã tính trong số vé TC Đón/Trả). Rê chuột vào số để xem chi tiết",
  "pages.transit_report.station.fields.companyId": "Nhà xe",
  "pages.transit_report.station.fields.vatDifference.tooltip": "Chênh lệch thuế = Thuế GTGT phải nộp (Doanh thu trước thuế x 8%) - Thuế GTGT khấu trừ (Phí trả đối tác vận chuyển trước thuế x 8%)",
  "pages.transit_report.station.fields.vatDifference": "Chênh lệch thuế",
  "pages.transit_report.station.company_revenue.title": "Báo cáo Doanh thu nhà xe theo bến",
  "pages.transit_report.station.fields.stopPointIds": "Bến xe",
  "pages.transit_report.station.tickets.title": "Báo cáo Trung chuyển bến xe theo vé",
  "pages.transit_report.title": "Báo cáo Trung chuyển theo vé",
  "pages.transit_surcharge_rules.actions.create": "Thêm rule mới",
  "pages.transit_surcharge_rules.actions.delete": "Xóa rule",
  "pages.transit_surcharge_rules.actions.edit": "Chỉnh sửa rule",
  "pages.transit_surcharge_rules.fields.index": "STT",
  "pages.transit_surcharge_rules.fields.isActive": "Trạng thái",
  "pages.transit_surcharge_rules.fields.name": "Tên rule",
  "pages.transit_surcharge_rules.fields.period": "Khoảng thời gian",
  "pages.transit_surcharge_rules.fields.surchargeValue": "Phụ thu",
  "pages.transit_surcharge_rules.fields.surchargeValueType": "Loại phụ thu",
  "pages.transit_surcharge_rules.fields.type": "Loại",
  "pages.transit_surcharge_rules.modal.cancelButton": "Đóng",
  "pages.transit_surcharge_rules.modal.deleteConfirmCancel": "Hủy",
  "pages.transit_surcharge_rules.modal.deleteConfirmContent": "Bạn có chắc chắn muốn xóa rule \"{name}\"?",
  "pages.transit_surcharge_rules.modal.deleteConfirmOk": "Xóa",
  "pages.transit_surcharge_rules.modal.deleteConfirmTitle": "Xác nhận xóa rule",
  "pages.transit_surcharge_rules.modal.fields.dateRange": "Khoảng ngày áp dụng",
  "pages.transit_surcharge_rules.modal.fields.dateRangeRequired": "Vui lòng chọn khoảng ngày",
  "pages.transit_surcharge_rules.modal.fields.endTime": "Giờ kết thúc",
  "pages.transit_surcharge_rules.modal.fields.endTimeRequired": "Vui lòng chọn giờ kết thúc",
  "pages.transit_surcharge_rules.modal.fields.isActive": "Trạng thái",
  "pages.transit_surcharge_rules.modal.fields.nameMaxLength": "Tên không được vượt quá 200 ký tự",
  "pages.transit_surcharge_rules.modal.fields.nameRequired": "Vui lòng nhập tên rule",
  "pages.transit_surcharge_rules.modal.fields.startTime": "Giờ bắt đầu",
  "pages.transit_surcharge_rules.modal.fields.startTimeRequired": "Vui lòng chọn giờ bắt đầu",
  "pages.transit_surcharge_rules.modal.fields.surchargeValue": "Giá trị phụ thu",
  "pages.transit_surcharge_rules.modal.fields.surchargeValueMax": "Giá trị phụ thu vượt quá giới hạn cho phép",
  "pages.transit_surcharge_rules.modal.fields.surchargeValueMaxDigits": "Giá trị phụ thu vượt quá giới hạn cho phép",
  "pages.transit_surcharge_rules.modal.fields.surchargeValuePercentageMax": "Giá trị phần trăm không được vượt quá 100%",
  "pages.transit_surcharge_rules.modal.fields.surchargeValuePercentageMin": "Giá trị phần trăm phải lớn hơn 0",
  "pages.transit_surcharge_rules.modal.fields.surchargeValueRequired": "Vui lòng nhập giá trị phụ thu",
  "pages.transit_surcharge_rules.modal.fields.surchargeValueType": "Loại phụ thu",
  "pages.transit_surcharge_rules.modal.fields.surchargeValueTypeRequired": "Vui lòng chọn loại phụ thu",
  "pages.transit_surcharge_rules.modal.fields.type": "Loại rule",
  "pages.transit_surcharge_rules.modal.fields.typeRequired": "Vui lòng chọn loại rule",
  "pages.transit_surcharge_rules.status.active": "Đang áp dụng",
  "pages.transit_surcharge_rules.status.inactive": "Tạm dừng",
  "pages.transit_surcharge_rules.surchargeValueType.amount": "Số tiền cố định (VNĐ)",
  "pages.transit_surcharge_rules.surchargeValueType.percentage": "Phần trăm (%)",
  "pages.transit_surcharge_rules.title": "Cấu hình Phụ thu Trung chuyển",
  "pages.transit_surcharge_rules.type.holiday": "Ngày Lễ",
  "pages.transit_surcharge_rules.type.time_slot": "Khung giờ",
  "pages.user.introduction.filter.text": "Bạn có thể thực hiện việc lọc dữ liệu bằng cách thiết lập các giá trị ở đây",
  "pages.user.introduction.filter.title": "Bộ lọc dữ liệu",
  "pages.user.introduction.filterMore.text": "Click vào đây để hiển thị thêm điều kiện lọc dữ liệu",
  "pages.user.introduction.filterMore.title": "Mở rộng lọc",
  "pages.user.introduction.tableSetting.text": "Làm mới dữ liệu, thiết lập hiển thị / ẩn các cột dữ liệu, đóng băng cột dữ liệu",
  "pages.user.introduction.tableSetting.title": "Cấu hình hiển thị",
  "pages.userList.actions.resetPassword": "Tạo lại mật khẩu",
  "pages.userList.detailForm.title": "Thông tin người dùng",
  "pages.userList.fields.active": "Trạng thái",
  "pages.userList.fields.mobile": "Điện thoại",
  "pages.userList.fields.mobile.invalid": "Số điện thoại không đúng định dạng",
  "pages.userList.fields.name": "Họ và tên",
  "pages.userList.fields.password": "Mật khẩu",
  "pages.userList.fields.password.placeholder": "Vui lòng nhập mật khẩu",
  "pages.userList.fields.password.required": "Hãy nhập mật khẩu!",
  "pages.userList.fields.pbac": "Quyền",
  "pages.userList.fields.pbac.placeholder": "Vui lòng chọn quyền",
  "pages.userList.fields.userName": "Tên đăng nhập",
  "pages.userList.fields.username": "Tên đăng nhập",
  "pages.userList.fields.username.placeholder": "Vui lòng nhập Tên đăng nhập",
  "pages.userList.newForm.button.nextStep": "Tiếp theo",
  "pages.userList.newForm.button.preStep": "Quay lại",
  "pages.userList.newForm.step1": "Tài khoản",
  "pages.userList.newForm.step2": "Thông tin",
  "pages.userList.newForm.title": "Tài khoản mới",
  "pages.userList.resetPasswordForm.newPassword": "Mật khẩu mới",
  "pages.userList.resetPasswordForm.title": "Tạo lại mật khẩu",
  "pages.userList.table.title": "Danh sách tài khoản nhân viên",
  "pages.userList.tips.userName": "Tên đăng nhập là duy nhất",
  "pages.userList.updateForm.title": "Cập nhật tài khoản",
  "pages.vehicleUtilities.fields.createdDate": "Ngày tạo",
  "pages.vehicleUtilities.fields.index": "STT",
  "pages.vehicleUtilities.fields.listImage": "Hình ảnh",
  "pages.vehicleUtilities.fields.name": "Tên tiện ích",
  "pages.vehicleUtilities.fields.name.placeholder": "Vui lòng nhập tên tiện ích",
  "pages.vehicleUtilities.fields.unit": "Đơn vị",
  "pages.vehicleUtilities.fields.unit.placeholder": "Vui lòng nhập đơn vị",
  "pages.vehicleUtilities.form.title": "Chỉnh sửa tiện ích",
  "pages.vehicleUtilities.form.upload": "Tải lên",
  "pages.vehicleUtilities.table.title": "Danh sách tiện ích",
  "pages.vehicleUtilities.title": "Quản lý tiện ích xe",
  "pages.vpbqr.payments.actions.callback_trigger": "Kiểm tra giao dịch",
  "pages.vpbqr.payments.detailForm.title": "Thông tin chi tiết giao dịch",
  "pages.vpbqr.payments.fields.actions": "Thao tác",
  "pages.vpbqr.payments.fields.billNumber": "Mã giao dịch",
  "pages.vpbqr.payments.fields.billNumber.tips": "Mã giao dịch của AV",
  "pages.vpbqr.payments.fields.callbackRespCode": "Kết quả callback",
  "pages.vpbqr.payments.fields.callbackRespDesc": "Nội dung callback",
  "pages.vpbqr.payments.fields.createdAt": "Ngày tạo",
  "pages.vpbqr.payments.fields.description": "Mô tả chi tiết",
  "pages.vpbqr.payments.fields.description.expand": "Xem thêm",
  "pages.vpbqr.payments.fields.feeAmount": "Tiền phí QR",
  "pages.vpbqr.payments.fields.ftCode": "Mã FT",
  "pages.vpbqr.payments.fields.ftCode.tips": "Mã ftCode, phục vụ đối soát và hoàn tiền sau này",
  "pages.vpbqr.payments.fields.notice": "Ghi chú",
  "pages.vpbqr.payments.fields.notice.expand": "Xem thêm",
  "pages.vpbqr.payments.fields.payDate": "Ngày thanh toán",
  "pages.vpbqr.payments.fields.qrPercentage": "Phí % QR",
  "pages.vpbqr.payments.fields.referenceLabelCode": "Mã giao dịch VPBank",
  "pages.vpbqr.payments.fields.referenceLabelCode.tips": "Mã giao dịch gửi sang VPBank",
  "pages.vpbqr.payments.fields.refundAmount": "Số tiền hoàn",
  "pages.vpbqr.payments.fields.status": "Trạng thái",
  "pages.vpbqr.payments.fields.terminalID": "Mã cổng",
  "pages.vpbqr.payments.fields.terminalID.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và VPBank",
  "pages.vpbqr.payments.fields.terminalName": "Tên cổng TT",
  "pages.vpbqr.payments.fields.terminalName.tips": "Mã nhà xe, hoặc tên cổng thanh toán",
  "pages.vpbqr.payments.fields.traceTransfer": "Số trace",
  "pages.vpbqr.payments.fields.traceTransfer.tips": "Số trace của hệ thống bank, do hệ thống bank tự sinh",
  "pages.vpbqr.payments.fields.transactionAmount": "Số tiền",
  "pages.vpbqr.payments.title": "Giao dịch thanh toán VPBank QR",
  "pages.vpbqr.terminals.actions.approve": "Phê duyệt",
  "pages.vpbqr.terminals.actions.delete": "Xóa",
  "pages.vpbqr.terminals.actions.deny": "Từ chối",
  "pages.vpbqr.terminals.actions.update": "Sửa thông tin",
  "pages.vpbqr.terminals.approveForm.title": "Phê duyệt cổng thanh toán VPBank QR",
  "pages.vpbqr.terminals.button.batchDeny": "Từ chối hàng loạt",
  "pages.vpbqr.terminals.createForm.title": "Đăng ký cổng thanh toán VPBank QR",
  "pages.vpbqr.terminals.detailForm.title": "Thông tin chi tiết cổng thanh toán VPBank QR",
  "pages.vpbqr.terminals.field.createdAt": "Ngày tạo",
  "pages.vpbqr.terminals.fields.bankAccountName": "Tên tài khoản",
  "pages.vpbqr.terminals.fields.bankAccountName.placeholder": "Nhập tên tài khoản ngân hàng",
  "pages.vpbqr.terminals.fields.bankAccountNumber": "Số tài khoản",
  "pages.vpbqr.terminals.fields.bankAccountNumber.placeholder": "Nhập số tài khoản ngân hàng",
  "pages.vpbqr.terminals.fields.identityNumber": "Số CCCD/CMT",
  "pages.vpbqr.terminals.fields.identityNumber.placeholder": "Nhập số CCCD/CMT",
  "pages.vpbqr.terminals.fields.merchantId": "Merchant ID VPBank",
  "pages.vpbqr.terminals.fields.merchantId.placeholder": "Nhập Merchant ID của VPBank (tùy chọn)",
  "pages.vpbqr.terminals.fields.phoneNo": "Số điện thoại",
  "pages.vpbqr.terminals.fields.phoneNo.placeholder": "Nhập số điện thoại",
  "pages.vpbqr.terminals.fields.qrPercentage": "Phí giao dịch",
  "pages.vpbqr.terminals.fields.status": "Trạng thái",
  "pages.vpbqr.terminals.fields.terminalId": "Mã cổng",
  "pages.vpbqr.terminals.fields.terminalId.placeholder": "Nhập mã cổng",
  "pages.vpbqr.terminals.fields.terminalId.tips": "ID định dạng cổng thanh toán của nhà xe trên AnVui và VPBank",
  "pages.vpbqr.terminals.fields.terminalName": "Tên cổng TT",
  "pages.vpbqr.terminals.fields.terminalName.placeholder": "Nhập tên terminal (Mã nhà xe, Mã khách hàng, Mã đối tác)",
  "pages.vpbqr.terminals.fields.terminalName.tips": "ID định danh của đối tác, mã nhà xe, mã khách hàng",
  "pages.vpbqr.terminals.fields.vaNumber": "Số tài khoản ảo VPBank",
  "pages.vpbqr.terminals.fields.vanStatus": "Trạng thái duyệt VPBank",
  "pages.vpbqr.terminals.fields.vanStatus.approved": "Đã duyệt",
  "pages.vpbqr.terminals.fields.vanStatus.pending": "Chờ duyệt",
  "pages.vpbqr.terminals.fields.vanStatus.rejected": "Bị từ chối",
  "pages.vpbqr.terminals.table.footerText": "| Chờ phê duyệt: {pending} | Bị từ chối: {deny}",
  "pages.vpbqr.terminals.table.title": "Danh sách cổng thanh toán VPBank QR",
  "pages.vpbqr.terminals.updateForm.title": "Cập nhật cổng thanh toán VPBank QR",
  "pages.vpbqr.vpbankCustomerSdkLog.actions.delete": "Xóa",
  "pages.vpbqr.vpbankCustomerSdkLog.actions.delete.confirm": "Bạn có chắc chắn muốn xóa log này?",
  "pages.vpbqr.vpbankCustomerSdkLog.actions.view": "Xem chi tiết",
  "pages.vpbqr.vpbankCustomerSdkLog.app.DRIVER": "Tài xế",
  "pages.vpbqr.vpbankCustomerSdkLog.app.TICKET_SALE": "Bán vé",
  "pages.vpbqr.vpbankCustomerSdkLog.detailForm.title": "Thông tin chi tiết log",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.app": "Loại ứng dụng",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.app.tips": "Loại ứng dụng",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.createdAt": "Ngày tạo",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.id": "ID",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.isSuccess": "Mở TK thành công",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.platform": "Nền tảng",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.platform.tips": "Nền tảng sử dụng",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.sessionId": "Session ID",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.sessionId.tips": "Session ID của khách hàng",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.status": "Trạng thái",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.status.tips": "Trạng thái",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.updatedAt": "Ngày cập nhật",
  "pages.vpbqr.vpbankCustomerSdkLog.fields.userPhone": "Số điện thoại",
  "pages.vpbqr.vpbankCustomerSdkLog.status.INIT": "Khởi tạo",
  "pages.vpbqr.vpbankCustomerSdkLog.status.LOGOUT": "Đăng xuất",
  "pages.vpbqr.vpbankCustomerSdkLog.status.SUCCESS": "Thành công",
  "pages.vpbqr.vpbankCustomerSdkLog.title": "VPBank Customer SDK Log",
  "pages.welcome.alertMessage": "Faster and stronger heavy-duty components have been released.",
  "permission.data.resource.balanceFluctuation": "Quản lý biến động số dư",
  "permission.data.resource.balanceFluctuation.action.refund": "Hoàn tiền",
  "permission.data.resource.balanceFluctuation.action.runPayFee": "Chạy phí định kỳ",
  "permission.data.resource.balanceFluctuation.action.view": "Xem biến động số dư",
  "permission.data.resource.bidvqr_payment": "BIDVQR - Giao dịch",
  "permission.data.resource.bidvqr_payment.action.callback-trigger": "Kiểm tra lại giao dịch",
  "permission.data.resource.bidvqr_payment.action.dashboard": "Báo cáo tổng quát",
  "permission.data.resource.bidvqr_payment.action.export": "Xuất excel giao dịch",
  "permission.data.resource.bidvqr_payment.action.refund": "Giao dịch hoàn tiền",
  "permission.data.resource.bidvqr_payment.action.report": "Giao dịch thanh toán",
  "permission.data.resource.bidvqr_terminal": "BIDVQR - Cổng thanh toán",
  "permission.data.resource.bidvqr_terminal.action.confirm": "Phê duyệt cổng thanh toán",
  "permission.data.resource.bidvqr_terminal.action.export": "Sửa thông tin cổng thanh toán",
  "permission.data.resource.bidvqr_terminal.action.remove": "Xóa cổng thanh toán",
  "permission.data.resource.bidvqr_terminal.action.view": "Xem danh sách cổng thanh toán",
  "permission.data.resource.brandname": "SMS Thương hiệu",
  "permission.data.resource.brandname.action.add": "Thêm thông tin SMS Thương hiệu",
  "permission.data.resource.brandname.action.remove": "Xóa SMS Thương hiệu",
  "permission.data.resource.brandname.action.update": "Sửa thông tin SMS Thương hiệu",
  "permission.data.resource.brandname.action.view": "Xem danh sách SMS Thương hiệu",
  "permission.data.resource.client": "Đối tác tích hợp",
  "permission.data.resource.client.action.add": "Thêm đối tác",
  "permission.data.resource.client.action.remove": "Xóa đối tác",
  "permission.data.resource.client.action.resetClientSecret": "Tạo lại mã bí mật",
  "permission.data.resource.client.action.update": "Sửa đối tác",
  "permission.data.resource.client.action.view": "Xem dữ liệu đối tác",
  "permission.data.resource.cloud_speaker": "Loa thanh toán",
  "permission.data.resource.cloud_speaker.action.add": "Thêm loa thanh toán",
  "permission.data.resource.cloud_speaker.action.remove": "Xóa loa thanh toán",
  "permission.data.resource.cloud_speaker.action.update": "Sửa thông tin loa thanh toán",
  "permission.data.resource.cloud_speaker.action.view": "Xem danh sách loa thanh toán",
  "permission.data.resource.company": "Quản lý nhà xe",
  "permission.data.resource.company.action.add": "Đăng ký nhà xe",
  "permission.data.resource.company.action.changeAccountBalance": "Thay đổi số dư tài khoản",
  "permission.data.resource.company.action.configFee": "Chỉnh sửa giá dịch vụ",
  "permission.data.resource.company.action.lock": "Khóa nhà xe",
  "permission.data.resource.company.action.remove": "Xóa nhà xe",
  "permission.data.resource.company.action.removeCompletely": "Xóa nhà xe hoàn toàn",
  "permission.data.resource.company.action.unlock": "Mở khóa nhà xe",
  "permission.data.resource.company.action.update": "Sửa thông tin nhà xe",
  "permission.data.resource.company.action.view": "Xem dữ liệu nhà xe",
  "permission.data.resource.companyAccount": "Tài khoản nhà xe",
  "permission.data.resource.companyAccount.action.resetPassword": "Đặt lại mật khẩu tài khoản nhà xe",
  "permission.data.resource.companyAccount.action.setAdmin": "Cấp quyền quản trị tài khoản nhà xe",
  "permission.data.resource.companyAccount.action.view": "Xem tài khoản nhà xe",
  "permission.data.resource.company_notification": "Quản lý thông báo nhà xe",
  "permission.data.resource.company_notification.action.add": "Thêm thông báo nhà xe",
  "permission.data.resource.company_notification.action.remove": "Xóa thông báo nhà xe",
  "permission.data.resource.company_notification.action.update": "Sửa thông báo nhà xe",
  "permission.data.resource.company_notification.action.view": "Xem danh sách thông báo nhà xe",
  "permission.data.resource.company_partner": "Quản lý đối tác nhà xe",
  "permission.data.resource.company_partner.action.add": "Thêm đối tác nhà xe",
  "permission.data.resource.company_partner.action.add_staff": "Thêm nhân viên đối tác nhà xe",
  "permission.data.resource.company_partner.action.deposit": "Nạp tiền đối tác nhà xe",
  "permission.data.resource.company_partner.action.remove": "Xóa đối tác nhà xe",
  "permission.data.resource.company_partner.action.update": "Sửa đối tác nhà xe",
  "permission.data.resource.company_partner.action.view": "Xem danh sách đối tác nhà xe",
  "permission.data.resource.company_payment_transaction": "Giao dịch thu phí nhà xe",
  "permission.data.resource.company_payment_transaction.action.create": "Tạo giao dịch",
  "permission.data.resource.company_payment_transaction.action.view": "Xem giao dịch",
  "permission.data.resource.config_web": "Web AnVui",
  "permission.data.resource.config_web.action.recruit": "Quản lý tuyển dụng",
  "permission.data.resource.config_web.action.update": "Sửa cấu hình",
  "permission.data.resource.customer": "Quản lý khách hàng tiềm năng",
  "permission.data.resource.customer.action.add": "Thêm thông tin khách hàng",
  "permission.data.resource.customer.action.delete": "Xóa thông tin khách hàng",
  "permission.data.resource.customer.action.update": "Sửa thông tin khách hàng",
  "permission.data.resource.customer.action.view": "Xem dữ liệu khách hàng",
  "permission.data.resource.customerLead": "Quản lý khách hàng mới",
  "permission.data.resource.customerLead.action.add": "Thêm thông tin khách hàng mới",
  "permission.data.resource.customerLead.action.delete": "Xóa thông tin khách hàng mới",
  "permission.data.resource.customerLead.action.update": "Sửa thông tin khách hàng mới",
  "permission.data.resource.customerLead.action.view": "Xem thông tin khách hàng mới",
  "permission.data.resource.customerStatus": "Quản lý trạng thái khách hàng",
  "permission.data.resource.customerStatus.action.add": "Thêm thông tin trạng thái khách hàng",
  "permission.data.resource.customerStatus.action.delete": "Xóa thông tin trạng thái khách hàng",
  "permission.data.resource.customerStatus.action.update": "Sửa thông tin trạng thái khách hàng",
  "permission.data.resource.customerStatus.action.view": "Xem thông tin trạng thái khách hàng",
  "permission.data.resource.dashboard": "Tổng quan",
  "permission.data.resource.dashboard.analytics": "Bản đồ vé",
  "permission.data.resource.dashboard.company-yearly-report": "Tình hình công ty",
  "permission.data.resource.dashboard.goods": "Hàng hóa",
  "permission.data.resource.dashboard.monitor": "Tài chính",
  "permission.data.resource.dashboard.tickets": "Vé",
  "permission.data.resource.dashboard.yearly-report": "Tổng kết năm",
  "permission.data.resource.dynamic_report": "Quản lý báo cáo động",
  "permission.data.resource.dynamic_report.action.add": "Thêm báo cáo động",
  "permission.data.resource.dynamic_report.action.remove": "Xóa báo cáo động",
  "permission.data.resource.dynamic_report.action.update": "Sửa báo cáo động",
  "permission.data.resource.dynamic_report.action.view": "Xem danh sách báo cáo động",
  "permission.data.resource.invoice-config": "Cấu hình kết nối VDT",
  "permission.data.resource.invoice-config.action.add": "Thêm thông tin cấu hình",
  "permission.data.resource.invoice-config.action.remove": "Xóa cấu hình",
  "permission.data.resource.invoice-config.action.update": "Sửa thông tin cấu hình",
  "permission.data.resource.invoice-config.action.view": "Xem danh sách cấu hình",
  "permission.data.resource.lhv_partner": "Thiết bị LHV Partner",
  "permission.data.resource.lhv_partner.action.reset": "Reset thiết bị",
  "permission.data.resource.lhv_partner.action.view": "Xem danh sách thiết bị",
  "permission.data.resource.mbqr_payment": "MBQR - Giao dịch",
  "permission.data.resource.mbqr_payment.action.callback-trigger": "Kiểm tra lại giao dịch",
  "permission.data.resource.mbqr_payment.action.dashboard": "Báo cáo tổng quát",
  "permission.data.resource.mbqr_payment.action.export": "Xuất excel giao dịch",
  "permission.data.resource.mbqr_payment.action.refund": "Giao dịch hoàn tiền",
  "permission.data.resource.mbqr_payment.action.report": "Giao dịch thanh toán",
  "permission.data.resource.mbqr_terminal": "MBQR - Cổng thanh toán",
  "permission.data.resource.mbqr_terminal.action.confirm": "Phê duyệt cổng thanh toán",
  "permission.data.resource.mbqr_terminal.action.export": "Sửa thông tin cổng thanh toán",
  "permission.data.resource.mbqr_terminal.action.remove": "Xóa cổng thanh toán",
  "permission.data.resource.mbqr_terminal.action.view": "Xem danh sách cổng thanh toán",
  "permission.data.resource.menuPackage": "Quản lý gói menu",
  "permission.data.resource.menuPackage.action.add": "Thêm thông tin gói menu",
  "permission.data.resource.menuPackage.action.delete": "Xóa thông tin gói menu",
  "permission.data.resource.menuPackage.action.update": "Sửa thông tin gói menu",
  "permission.data.resource.menuPackage.action.view": "Xem dữ liệu gói menu",
  "permission.data.resource.merchant_payment": "Quản lý cổng thanh toán merchant",
  "permission.data.resource.merchant_payment.action.add": "Thêm cổng thanh toán",
  "permission.data.resource.merchant_payment.action.remove": "Xóa cổng thanh toán",
  "permission.data.resource.merchant_payment.action.update": "Sửa thông tin cổng thanh toán",
  "permission.data.resource.merchant_payment.action.view": "Xem danh sách cổng thanh toán",
  "permission.data.resource.napasqr_payment": "NapasQR - Giao dịch",
  "permission.data.resource.napasqr_payment.action.callback-trigger": "Kiểm tra lại giao dịch",
  "permission.data.resource.napasqr_payment.action.dashboard": "Báo cáo tổng quát",
  "permission.data.resource.napasqr_payment.action.export": "Xuất excel giao dịch",
  "permission.data.resource.napasqr_payment.action.report": "Giao dịch thanh toán",
  "permission.data.resource.partner": "Quản lý đối tác",
  "permission.data.resource.partner.action.add": "Thêm đối tác",
  "permission.data.resource.partner.action.remove": "Xóa đối tác",
  "permission.data.resource.partner.action.update": "Sửa thông tin đối tác",
  "permission.data.resource.partner.action.view": "Xem danh sách đối tác",
  "permission.data.resource.paymentPackage": "Quản lý gói khuyến mãi",
  "permission.data.resource.paymentPackage.action.add": "Thêm thông tin gói khuyến mãi",
  "permission.data.resource.paymentPackage.action.remove": "Xóa thông tin gói khuyến mãi",
  "permission.data.resource.paymentPackage.action.update": "Sửa thông tin gói khuyến mãi",
  "permission.data.resource.paymentPackage.action.view": "Xem thông tin gói khuyến mãi",
  "permission.data.resource.permission": "Phân quyền hệ thống",
  "permission.data.resource.permission.action.add": "Thêm phân quyền",
  "permission.data.resource.permission.action.company_charge_wallet": "Nhà xe nạp tiền",
  "permission.data.resource.permission.action.remove": "Xóa phân quyền",
  "permission.data.resource.permission.action.update": "Sửa phân quyền",
  "permission.data.resource.permission.action.view": "Xem dữ liệu phân quyền",
  "permission.data.resource.report": "Báo cáo",
  "permission.data.resource.report.action.company_revenue": "Doanh thu nhà xe",
  "permission.data.resource.system": "Hệ thống",
  "permission.data.resource.system.service_restart": "Khởi động lại hệ thống",
  "permission.data.resource.system_banner": "Quản lý banner",
  "permission.data.resource.system_banner.add": "Thêm banner",
  "permission.data.resource.system_banner.delete": "Xóa banner",
  "permission.data.resource.system_banner.update": "Sửa banner",
  "permission.data.resource.system_banner.view": "Xem danh sách banner",
  "permission.data.resource.transit_anvui_stop_point": "Quản lý điểm dừng AnVui",
  "permission.data.resource.transit_anvui_stop_point.action.add": "Thêm điểm dừng",
  "permission.data.resource.transit_anvui_stop_point.action.remove": "Xóa điểm dừng",
  "permission.data.resource.transit_anvui_stop_point.action.update": "Sửa thông tin điểm dừng",
  "permission.data.resource.transit_anvui_stop_point.action.view": "Xem danh sách điểm dừng",
  "permission.data.resource.transit_surcharge_rule": "Cấu hình Phụ thu Trung chuyển",
  "permission.data.resource.transit_surcharge_rule.action.add": "Thêm rule phụ thu",
  "permission.data.resource.transit_surcharge_rule.action.remove": "Xóa rule phụ thu",
  "permission.data.resource.transit_surcharge_rule.action.update": "Chỉnh sửa rule phụ thu",
  "permission.data.resource.transit_surcharge_rule.action.view": "Xem danh sách rule phụ thu",
  "permission.data.resource.transit_with_partner": "Quản lý dịch vụ vận chuyển với đối tác",
  "permission.data.resource.transit_with_partner.action.add": "Thêm dịch vụ vận chuyển",
  "permission.data.resource.transit_with_partner.action.cancel_order": "Hủy đơn hàng",
  "permission.data.resource.transit_with_partner.action.config_fee": "Cấu hình phí trung chuyển",
  "permission.data.resource.transit_with_partner.action.dashboard": "Báo cáo tổng quát",
  "permission.data.resource.transit_with_partner.action.detailed_report": "Báo cáo chi tiết vé trung chuyển NX",
  "permission.data.resource.transit_with_partner.action.detailed_report.export": "Xuất excel báo cáo vé trung chuyển NX",
  "permission.data.resource.transit_with_partner.action.detailed_report.staff_revenue_view": "Xem báo cáo doanh thu nhân viên trung chuyển NX",
  "permission.data.resource.transit_with_partner.action.detailed_report.ticket_view": "Xem báo cáo vé trung chuyển NX",
  "permission.data.resource.transit_with_partner.action.export": "Xuất excel",
  "permission.data.resource.transit_with_partner.action.remove": "Xóa dịch vụ vận chuyển",
  "permission.data.resource.transit_with_partner.action.report": "Báo cáo chi tiết",
  "permission.data.resource.transit_with_partner.action.station_report": "Báo cáo trung chuyển bến xe",
  "permission.data.resource.transit_with_partner.action.station_report.revenue_view": "Xem báo cáo doanh thu nhà xe theo bến",
  "permission.data.resource.transit_with_partner.action.station_report.ticket_view": "Xem báo cáo vé trung chuyển bến xe",
  "permission.data.resource.transit_with_partner.action.update": "Sửa đơn trung chuyển",
  "permission.data.resource.transit_with_partner.action.update_admin": "Sửa đơn trung chuyển (Admin)",
  "permission.data.resource.transit_with_partner.action.view": "Xem dữ liệu dịch vụ vận chuyển",
  "permission.data.resource.user": "Tài khoản nhân viên",
  "permission.data.resource.user.action.add": "Thêm tài khoản",
  "permission.data.resource.user.action.remove": "Xóa tài khoản",
  "permission.data.resource.user.action.resetpass": "Tạo lại mật khẩu",
  "permission.data.resource.user.action.update": "Sửa tài khoản",
  "permission.data.resource.user.action.view": "Xem dữ liệu tài khoản",
  "permission.data.resource.vehicle_utilities": "Quản lý tiện ích xe",
  "permission.data.resource.vehicle_utilities.action.add": "Thêm tiện ích xe",
  "permission.data.resource.vehicle_utilities.action.remove": "Xóa tiện ích xe",
  "permission.data.resource.vehicle_utilities.action.update": "Sửa thông tin tiện ích xe",
  "permission.data.resource.vehicle_utilities.action.view": "Xem danh sách tiện ích xe",
  "permission.data.resource.vpbqr_customer_sdk_log": "VPBankQR - Khách hàng đăng ký TK VPBank",
  "permission.data.resource.vpbqr_customer_sdk_log.action.delete": "Xóa log",
  "permission.data.resource.vpbqr_customer_sdk_log.action.export": "Xuất excel log",
  "permission.data.resource.vpbqr_customer_sdk_log.action.view": "Xem danh sách log",
  "permission.data.resource.vpbqr_payment": "VPBankQR - Giao dịch",
  "permission.data.resource.vpbqr_payment.action.callback-trigger": "Kiểm tra lại giao dịch",
  "permission.data.resource.vpbqr_payment.action.dashboard": "Báo cáo tổng quát",
  "permission.data.resource.vpbqr_payment.action.export": "Xuất excel giao dịch",
  "permission.data.resource.vpbqr_payment.action.report": "Giao dịch thanh toán",
  "permission.data.resource.vpbqr_terminal": "VPBankQR - Cổng thanh toán",
  "permission.data.resource.vpbqr_terminal.action.confirm": "Phê duyệt cổng thanh toán",
  "permission.data.resource.vpbqr_terminal.action.remove": "Xóa cổng thanh toán",
  "permission.data.resource.vpbqr_terminal.action.update": "Sửa thông tin cổng thanh toán",
  "permission.data.resource.vpbqr_terminal.action.view": "Xem danh sách cổng thanh toán",
  "permission.data.resource.zaloOaAccount": "Tài khoản ZaloOA",
  "permission.data.resource.zaloOaAccount.action.add": "Thêm tài khoản ZaloOA",
  "permission.data.resource.zaloOaAccount.action.remove": "Xóa tài khoản ZaloOA",
  "permission.data.resource.zaloOaAccount.action.update": "Sửa tài khoản ZaloOA",
  "permission.data.resource.zaloOaAccount.action.view": "Xem tài khoản ZaloOA",
  "transit.actions.call": "Gọi điện",
  "transit.actions.cancel": "Hủy trung chuyển",
  "transit.actions.deleteGroup": "Xóa nhóm",
  "transit.actions.detailTransit": "Chi tiết",
  "transit.actions.historyTransit": "Lịch sử thay đổi",
  "transit.actions.notify": "Gửi thông báo đón",
  "transit.actions.removeGroup": "Xóa khỏi nhóm",
  "transit.actions.return": "Gửi thông báo trả",
  "transit.actions.viewMap": "Xem bản đồ",
  "transit.history.actions.cancel": "Hủy đơn hàng",
  "transit.history.actions.sync": "Đồng bộ dữ liệu",
  "transit.history.actions.update": "Cập nhật thông tin",
  "transit.history.actions.viewHistory": "Xem lịch sử thay đổi",
  "transit.text.operating": "Hành động",
  "transitWithPartner.coordinationHistory.modal.title": "Lịch sử thay đổi đơn hàng",
  "transitWithPartner.coordinationHistory.table.action": "Hành động",
  "transitWithPartner.coordinationHistory.table.action.cancelled": "Hủy",
  "transitWithPartner.coordinationHistory.table.action.created": "Tạo mới",
  "transitWithPartner.coordinationHistory.table.action.statusChanged": "Đổi trạng thái",
  "transitWithPartner.coordinationHistory.table.action.updated": "Cập nhật",
  "transitWithPartner.coordinationHistory.table.actor": "Người thực hiện",
  "transitWithPartner.coordinationHistory.table.changedFields": "Chi tiết thay đổi",
  "transitWithPartner.coordinationHistory.table.createdAt": "Thời gian",
  "validations.email_inccorect": "Email không đúng định dạng",
  "validations.max": "Độ dài tối đa: {max} ký tự",
  "validations.min": "Độ dài tối thiểu: {min} ký tự",
  "validations.mobile_phone_incorrect": "Số điện thoại không đúng định dạng",
  "validations.required": "Bắt buộc"
}
